import { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Link,
  SwipeableDrawer,
  TextField,
  Grid,
  Backdrop,
} from '@mui/material';
import { GenieIconNew, ResumeIconNew, GMailIcon, WhatsAppIcon, LoadingCogSvg, PiPEmptyStateSvg } from '../components/SvgIcon/SvgIcon';
import {
  AccessTime,
  Assignment,
  ContentCopy,
  PictureInPictureAlt,
  ShareOutlined,
  Link as LinkIcon,
  Close as CloseIcon,
  ContentCopy as ContentCopyIcon,
} from '@mui/icons-material';
import MeetingTitle from '../components/MeetingTitle';
import AudioControl from '../components/AudioControl/AudioControl';
import DotsLoader from '../components/DotsLoader/DotsLoader';
import PlayCircleIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import { WhatsappShareButton } from 'react-share';
import TranscriptionImg from '../assets/images/meeting-transcription-img.svg';
import { useDocumentPiP } from '../hooks/useDocumentPiP';
import DocumentPiP from '../components/DocumentPiP/DocumentPiP';
import PiPContent from '../components/PiPContent/PiPContent';
import MeetingMinutesEditor from '../components/summary';
import StartTime from '@mui/icons-material/AccessTime';
import copy from 'copy-to-clipboard';
import {
  resetRecording,
  setCurrentRecording,
} from '../redux/actions/currentRecording';
import { useTranscriber } from '../hooks/useTranscriber';
import axios from 'axios';
import { API_URL } from '../config/apiUrl';
import { openSnackbar } from '../redux/actions/snackbarAction';
import { fetchUserCredits } from '../redux/userSlice';
// import { useVoiceActivityDetection } from '../vad/useVoiceActivityDetection';
// import InactivityDialog from '../vad/InactivityDialog';
import { coerceDurationToSeconds } from '../utils/time';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useWakeLock } from 'react-screen-wake-lock';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { isTranscriptRoute, ROUTES } from '../routes';
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';
// Import Prism language components
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-c';
import 'prismjs/components/prism-cpp';
import 'prismjs/components/prism-csharp';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-rust';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-markup'; // HTML is part of markup
import { isMobile, isTablet } from 'react-device-detect';
import { Tabs, Tab } from '@mui/material';
import { Mic, Stop, Pause, PlayArrow, Computer, FiberManualRecord } from '@mui/icons-material';
import { isBrowser } from 'react-device-detect';
import RotatingText from '../components/DotsLoader/DotsLoader';
// Configure marked with enhanced options for GFM-like support
marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: true,
  mangle: false,
});

function markdownToQuill(markdown) {
  if (!markdown) return '';

  // Convert escaped newline characters (\n) into real newlines
  // so marked can properly detect block-level syntax like tables
  const processedMarkdown = markdown.replace(/\\n/g, '\n');

  // Parse markdown with enhanced options
  const rawHtml = marked.parse(processedMarkdown, {
    breaks: true,
    gfm: true,
    headerIds: true,
    mangle: false,
  });

  const cleanHtml = DOMPurify.sanitize(rawHtml, {
    ADD_TAGS: ['pre', 'code', 'table', 'thead', 'tbody', 'tr', 'th', 'td'],
    ADD_ATTR: ['class', 'data-language'],
  });

  // Create a DOM parser to manipulate the HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(cleanHtml, 'text/html');

  // Add markdown class to the root for styling
  const body = doc.body;
  body.classList.add('markdown-content');

  // Fix list items to prevent double bullets in Quill
  // Quill expects list items without nested paragraphs for simple lists
  const listItems = doc.querySelectorAll('li');
  listItems.forEach(li => {
    // Check if list item only contains a single paragraph with text
    const paragraphs = li.querySelectorAll('p');
    if (paragraphs.length === 1 && paragraphs[0].children.length === 0) {
      // Single paragraph with only text - unwrap it to prevent double bullets
      const p = paragraphs[0];
      const text = p.textContent;
      // Clear the list item and add text directly
      li.innerHTML = '';
      li.appendChild(doc.createTextNode(text));
    } else if (paragraphs.length > 0) {
      // Multiple paragraphs or paragraphs with children - keep structure but clean up
      paragraphs.forEach(p => {
        // If paragraph only contains text (no other block elements), unwrap it
        const hasBlockElements = p.querySelector(
          'div, p, ul, ol, h1, h2, h3, h4, h5, h6, pre, blockquote'
        );
        if (!hasBlockElements && p.textContent.trim()) {
          // Unwrap the paragraph, keeping its content
          const parent = p.parentNode;
          const fragment = doc.createDocumentFragment();
          while (p.firstChild) {
            fragment.appendChild(p.firstChild);
          }
          // Add a line break if there's content after
          if (p.nextSibling) {
            fragment.appendChild(doc.createElement('br'));
          }
          parent.replaceChild(fragment, p);
        }
      });
    }

    // Clean up any empty text nodes
    const walker = doc.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() === '') {
        textNodes.push(node);
      }
    }
    textNodes.forEach(textNode => textNode.remove());
  });

  // Enhance code blocks with syntax highlighting
  const codeBlocks = doc.querySelectorAll('pre > code');
  codeBlocks.forEach(codeEl => {
    const parentPre = codeEl.parentElement;
    // Extract language from class (handles both 'language-xxx' and 'xxx' formats)
    let language = '';
    const classMatch = codeEl.className.match(/language-?(\w+)/);
    if (classMatch) {
      language = classMatch[1];
    } else if (codeEl.className) {
      language = codeEl.className.split(' ')[0];
    }

    if (!language || language === 'text') {
      language = 'text';
    }

    // Add language class to pre element for Quill
    parentPre.className = `language-${language} ql-syntax`;

    // Highlight syntax using Prism
    try {
      // Map common language aliases
      const languageMap = {
        html: 'markup',
        xml: 'markup',
        svg: 'markup',
        js: 'javascript',
        ts: 'typescript',
        py: 'python',
        rb: 'ruby',
        sh: 'bash',
        yml: 'yaml',
      };
      const mappedLanguage = languageMap[language] || language;

      if (
        mappedLanguage &&
        mappedLanguage !== 'text' &&
        Prism.languages[mappedLanguage]
      ) {
        const codeText = codeEl.textContent || codeEl.innerText;
        const highlighted = Prism.highlight(
          codeText,
          Prism.languages[mappedLanguage],
          mappedLanguage
        );
        codeEl.innerHTML = highlighted;
        codeEl.className = `language-${mappedLanguage}`;
      } else {
        // If language not supported, keep original content
        codeEl.className = `language-${language}`;
      }
    } catch (e) {
      // If highlighting fails, keep original content
      codeEl.className = `language-${language}`;
    }
  });

  // Enhance tables with better structure
  const tables = doc.querySelectorAll('table');
  tables.forEach(table => {
    table.classList.add('markdown-table');

    // Wrap table in a container that Quill recognizes as a BlockEmbed
    const parent = table.parentElement;
    if (
      !parent ||
      !parent.classList ||
      !parent.classList.contains('ql-table-embed')
    ) {
      const wrapper = doc.createElement('div');
      wrapper.className = 'ql-table-embed';
      wrapper.style.cssText = 'overflow-x: auto; margin: 16px 0;';
      if (parent) {
        parent.insertBefore(wrapper, table);
      }
      wrapper.appendChild(table);
    }

    // Ensure table has proper structure with thead and tbody
    if (!table.querySelector('thead') && table.querySelector('tr')) {
      const allRows = Array.from(table.querySelectorAll('tr'));
      if (allRows.length > 0) {
        const firstRow = allRows[0];
        const remainingRows = allRows.slice(1);

        // Create thead with first row
        const thead = doc.createElement('thead');
        const headerRow = firstRow.cloneNode(true);

        // Convert first row cells to th
        const cells = Array.from(headerRow.querySelectorAll('td, th'));
        cells.forEach(cell => {
          const th = doc.createElement('th');
          th.innerHTML = cell.innerHTML;
          // Copy attributes
          Array.from(cell.attributes).forEach(attr => {
            th.setAttribute(attr.name, attr.value);
          });
          cell.parentNode.replaceChild(th, cell);
        });

        thead.appendChild(headerRow);

        // Create tbody with remaining rows
        const tbody = doc.createElement('tbody');
        remainingRows.forEach(row => {
          tbody.appendChild(row);
        });

        // Rebuild table structure
        table.innerHTML = '';
        table.appendChild(thead);
        if (tbody.children.length > 0) {
          table.appendChild(tbody);
        }
      }
    }
  });

  // Find all <pre><code class="language-markdown">...</code></pre> and re-render
  const markdownCodeBlocks = doc.querySelectorAll(
    'pre > code.language-markdown'
  );
  markdownCodeBlocks.forEach(codeEl => {
    const parentPre = codeEl.parentElement;
    const innerMarkdown = codeEl.textContent;
    const reRenderedHtml = marked.parse(innerMarkdown, {
      breaks: true,
      gfm: true,
    });
    const sanitized = DOMPurify.sanitize(reRenderedHtml);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sanitized;
    parentPre.replaceWith(...tempDiv.childNodes);
  });

  return doc.body.innerHTML;
}

function normalizeTranscriptContent(text) {
  if (typeof text !== 'string') return '';
  const trimmed = text.trim();
  if (!trimmed) return '';

  const looksLikeHtml = /<\s*\/?\s*(div|p|br|span|ul|ol|li|pre|code|h[1-6])\b/i.test(
    text
  );
  if (looksLikeHtml)
    return text.replace(/--Resumed--/g, '<strong>--Resumed--</strong>');

  const lines = text.replace(/\r\n/g, '\n').split('\n');
  const blocks = [];

  const makeResumedBold = str =>
    str.replace(/--Resumed--/g, '<strong>--Resumed--</strong>');

  lines.forEach((line, idx) => {
    const lineHtml = line ? makeResumedBold(line) : '';
    const isResumedLine = line && /--Resumed--/i.test(line);

    // Add blank line above --Resumed-- (except before first block)
    if (isResumedLine && blocks.length > 0) {
      blocks.push('<div><br /></div>');
    }
    blocks.push(line ? `<div>${lineHtml}</div>` : '<div><br /></div>');
    // Add blank line below --Resumed--
    if (isResumedLine) {
      blocks.push('<div><br /></div>');
    }
  });

  return blocks.join('');
}

function HtmlToText(htmlString) {
  // Function to convert HTML to plain text
  const convertToText = html => {
    // Ensure newlines for block-level elements
    html = html
      .replace(/<\/p>/gi, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/li>/gi, '\n')
      .replace(/<\/h[1-6]>/gi, '\n')
      .replace(/<\/ul>/gi, '\n')
      .replace(/<\/ol>/gi, '\n')
      .replace(/<\/div>/gi, '\n');

    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    return tempElement.innerText.replace(/\n\s*\n\s*\n/g, '\n\n'); // remove triple newlines
  };

  return convertToText(htmlString);
}
function isQuillContentBlank(html) {
  if (!html || typeof html !== 'string') return true;

  // Remove tags like <p>, <h1> etc. but keep the text content
  const stripped = html
    .replace(/<[^>]+>/g, '') // remove all HTML tags
    .replace(/&nbsp;/g, '') // remove non-breaking spaces
    .replace(/\s/g, ''); // remove all whitespace characters

  return stripped === '';
}

function TranscriberDetail(props = {}) {
  // React Router hooks
  const location = useLocation();
  const navigate = useNavigate();
  const { meetingId: urlMeetingId } = useParams();

  // App Context for shared state
  const {
    details,
    setDetails,
    meetingAPIDetails,
    setMeetingAPIDetails,
    loading,
    setLoading,
    formatDateTime,
  } = useAppContext();

  // Determine current route info
  const currentPath = location.pathname;
  const isOnTranscriptRoute = isTranscriptRoute(currentPath);
  const isViewingMeetingFromUrl = Boolean(urlMeetingId);

  const prevPathRef = useRef(currentPath);

  useEffect(() => {
    if (currentPath === ROUTES.HOME && details?.isDetailsView) {
      setDetails({});
      setMeetingAPIDetails({});
      setShowSummary(false);
      setSummaryContext('');
    }
  }, [currentPath, details?.isDetailsView, setDetails, setMeetingAPIDetails]);

  // Reset to start screen when navigating back to home after a stopped meeting.
  // Only fires on actual navigation (previous path was different), not when
  // stopping a meeting while already on the home page.
  useEffect(() => {
    const navigatedToHome =
      currentPath === ROUTES.HOME && prevPathRef.current !== ROUTES.HOME;
    prevPathRef.current = currentPath;

    if (!navigatedToHome) return;

    const {
      stopped: wasStopped,
      isRecording: wasRecording,
      isFinalizing: wasFinalizing,
      isStarted: wasStarted,
    } = store.getState().currentMeetingDetails;

    if (wasStopped && !wasRecording && !wasFinalizing && !wasStarted) {
      dispatch(resetRecording());
      resetAll();
      clearMicList();
      resetTimer();
      setDetails({});
      setMeetingAPIDetails({});
      setShowSummary(false);
      setSummaryContext('');
      setHasFirstChunk(false);
    }
  }, [currentPath]);

  const currentMeetingDetails = useSelector(
    state => state.currentMeetingDetails
  );
  const websocketConnection = useSelector(
    state => state.currentMeetingDetails.websocketConnection
  );
  // Subscribe to recordingTime separately to ensure timer updates in mobile view
  const recordingTimeFromRedux = useSelector(
    state => state.currentMeetingDetails.recordingTime
  );
  const {
    meetingTitle,
    isEditingTitle,
    setIsEditingTitle,
    isRecording,
    content,
    micDevice,
    paused,
    summary,
    recordingTime: recordingTimeFromState,
    transcript,
    start_time,
    meetingContext,
    stopped,
    isStarted,
    meeting_id,
    audioControlDisabled,
    autoPaused,
    vadEnabled,
  } =
    Object.keys(meetingAPIDetails).length > 0 &&
    details.isDetailsView
      ? meetingAPIDetails
      : currentMeetingDetails;
  
  // Always use Redux recordingTime when recording is active to ensure timer updates
  // Use direct Redux subscription for real-time updates
  const recordingTime = isRecording || isStarted 
    ? recordingTimeFromRedux 
    : recordingTimeFromState;

  const dispatch = useDispatch();
  const store = useStore();
  const transScriptSession = useSelector(
    state => state.sessionDetail.transScriptSession
  );

  // On reload when URL is /transcribe/meeting/:id or /transcribe/bin/meeting/:id, restore meeting
  // view by setting details from the URL so fetchMeetingDetails runs and shows the meeting (not home).
  useEffect(() => {
    if (!urlMeetingId || Object.keys(details).length > 0 || !transScriptSession) return;
    const isBinRoute = currentPath.startsWith('/transcribe/bin/meeting/');
    setDetails({
      meetingDetails: { id: urlMeetingId },
      isDetailsView: true,
      ...(isBinRoute && { includeDeleted: true }),
    });
  }, [urlMeetingId, currentPath, transScriptSession, details, setDetails]);

  const credits = useSelector(state => state.user.credits);
  const creditsStatus = useSelector(state => state.user.status); // Get the fetch status

  const isStartDisabled = credits <= 0;
  const isLoadingCredits =
    creditsStatus === 'loading' || creditsStatus === 'idle';
  const isDisabled = isStartDisabled || isLoadingCredits;
  //customeHook
  const {
    isRecordingHook,
    isPaused,
    isStopped,
    streamRef,
    // vadAnalyserRef,
    // audioCtxRef,
    hasTranscript,
    isWebSocketOpen,
    connectWebSocket,
    startRecording,
    stopRecording,
    pauseRecording,
    // autoPauseRecording,
    resumeRecording,
    generateMOM,
    resetTimer,
    microphones,
    activeMicrophone,
    volume,
    microphoneError,
    isMicActive,
    isSystemActive,
    selectMicrophone,
    clearMicSpeaker,
    clearMicList,
    resetAll,
  } = useTranscriber({
    updateStatus: () => {},

    addTranscript: (text, isFinal) => {
      // Mark that we've received the first chunk
      setHasFirstChunk(true);
      const lineHtml = String(text).replace(
        /--Resumed--/g,
        '<strong>--Resumed--</strong>'
      );
      dispatch(
        setCurrentRecording({
          transcriptAppend: text,
          contentAppend: `<div>${lineHtml}</div>`,
        })
      );
    },

    updateTimer: seconds => {
      dispatch(
        setCurrentRecording({
          recordingTime: seconds,
        })
      );
    },

    displayMomContent: (html, isError, message) => {
      dispatch(
        setCurrentRecording({
          summary: html,
        })
      );
      if (isError) {
        // MOM error
      }
    },
  });

  // Wake Lock API integration to prevent system sleep during meetings
  const wakeLockActiveRef = useRef(false);
  const { isSupported, request, release } = useWakeLock({
    onRequest: () => {
      wakeLockActiveRef.current = true;
    },
    onError: () => {},
    onRelease: () => {
      wakeLockActiveRef.current = false;
    },
    reacquireOnPageVisible: true,
  });

  const requestRef = useRef(request);
  const releaseRef = useRef(release);
  requestRef.current = request;
  releaseRef.current = release;

  // Manage wake lock based on recording state (only when isRecording or isSupported changes)
  useEffect(() => {
    if (!isSupported) {
      return;
    }

    const manageWakeLock = async () => {
      try {
        if (isRecording && !wakeLockActiveRef.current) {
          wakeLockActiveRef.current = true;
          await requestRef.current();
        } else if (!isRecording && wakeLockActiveRef.current) {
          wakeLockActiveRef.current = false;
          await releaseRef.current();
        }
      } catch (wakeLockError) {
        wakeLockActiveRef.current = false;
      }
    };

    manageWakeLock();

    return () => {
      if (wakeLockActiveRef.current) {
        releaseRef.current().finally(() => {
          wakeLockActiveRef.current = false;
        });
      }
    };
  }, [isRecording, isSupported]);

  // State declarations - must be before VAD hook that uses them
  // const [inactivityDialogOpen, setInactivityDialogOpen] = useState(false);
  // /** Ref so onSilenceTimeout (called async from VAD) sees latest recording time; used to avoid showing modal on first render. */
  // const recordingTimeRef = useRef(0);
  // recordingTimeRef.current = recordingTime;
  // Track tab visibility to control PiP visibility on home route
  const [isTabHidden, setIsTabHidden] = useState(() => document.hidden);
  // const [vadSilenceDuration, setVadSilenceDuration] = useState(0);
  const [hasEnded, setHasEnded] = useState(false);
  const [isHome, setIsHome] = useState(!isRecording);
  
  const [showSummary, setShowSummary] = useState(false);
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const [summaryContext, setSummaryContext] = useState('');
  const [hasFirstChunk, setHasFirstChunk] = useState(false);
  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [isLoadingShare, setIsLoadingShare] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);
  const [pipLastSourceDialogOpen, setPipLastSourceDialogOpen] = useState(false);
  const [pipPendingSourceAction, setPipPendingSourceAction] = useState(null);

  // VAD (Voice Activity Detection) integration - Silero VAD commented out
  // const vadEnabledCondition =
  //   vadEnabled !== false && isRecording && !paused && !stopped;
  // const {
  //   isInitialized: vadInitialized,
  //   isSpeaking,
  //   silenceDuration,
  //   resetSilenceTimer,
  // } = useVoiceActivityDetection({
  //   analyserNodeRef: vadAnalyserRef,
  //   audioContextRef: audioCtxRef,
  //   enabled: vadEnabledCondition,
  //   silenceThresholdMs: 60000,
  //   onSilenceTimeout: () => {
  //     const elapsedSeconds = Number(recordingTimeRef.current) || 0;
  //     if (elapsedSeconds < 60) return;
  //     if (!autoPaused && isRecording && !paused) {
  //       autoPauseRecording();
  //       setVadSilenceDuration(60000);
  //       setInactivityDialogOpen(true);
  //     }
  //   },
  //   onSpeechDetected: () => {},
  // });
  // useEffect(() => {
  //   if (inactivityDialogOpen) setVadSilenceDuration(silenceDuration);
  // }, [silenceDuration, inactivityDialogOpen]);
  // const handleInactivityResume = () => {
  //   setInactivityDialogOpen(false);
  //   resetSilenceTimer();
  //   resumeRecording();
  // };
  // const handleInactivityStop = async (isManual = false) => {
  //   setInactivityDialogOpen(false);
  //   dispatch(
  //     setCurrentRecording({
  //       lastAutoStopReason: isManual ? 'manual_inactivity' : 'inactivity',
  //       stopped: true,
  //       isRecording: false,
  //       isFinalizing: true,
  //     })
  //   );
  //   try {
  //     await stopRecording();
  //   } finally {
  //     clearMicSpeaker();
  //     if (transScriptSession) {
  //       dispatch(fetchUserCredits(transScriptSession));
  //     }
  //     dispatch(
  //       setCurrentRecording({
  //         shouldOpenSummarizeDialog: true,
  //       })
  //     );
  //     dispatch(setCurrentRecording({ isFinalizing: false }));
  //   }
  // };

  // Listen for mic icon click from navbar to auto-start meeting
  useEffect(() => {
    const handleStartFromMic = () => {
      // Only proceed if not disabled
      if (isDisabled) {
        return;
      }
      
      // Always clear meeting details and reset state before starting new meeting
      setDetails({});
      setMeetingAPIDetails({});
      setIsHome(false);
      setShowSummary(false);
      setSummaryContext('');
      dispatch(resetRecording());
      resetAll();
      clearMicList();
      resetTimer();
      clearMicSpeaker();
      
      setTimeout(() => {
        dispatch(setCurrentRecording({ isStarted: true }));
      }, 800);
    };
    
    window.addEventListener('startMeetingFromMic', handleStartFromMic);
    return () => window.removeEventListener('startMeetingFromMic', handleStartFromMic);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);
  const currentTitleRef = useRef('');
  const transcriptContentRef = useRef(null);
  const prevScrollHeightRef = useRef(0);
  const prevScrollTopRef = useRef(0);
  const prevClientHeightRef = useRef(0);
  const prevShowSummaryRef = useRef(showSummary);
  const resumeConnectAttemptedRef = useRef(false);
  const resumeMicStartedRef = useRef(false);
  const lastResumeMeetingIdRef = useRef(null);
  const lastFetchedMeetingIdForStoppedRef = useRef(null);
  const stoppedTranscriptRetryCountRef = useRef(0);
  const stoppedTranscriptRetryTimerRef = useRef(null);
  const [stoppedTranscriptRetryTrigger, setStoppedTranscriptRetryTrigger] = useState(0);
  const isDetailsView =
    Object.keys(details).length > 0 && details.isDetailsView;
  const detailsStatus = isDetailsView
    ? (details.meetingDetails?.status || '')
        .toString()
        .trim()
        .toLowerCase()
    : '';
  const isDetailsFull = detailsStatus === 'full';
  const summarySources = [
    summaryContext,
    summary,
    currentMeetingDetails?.summary,
  ];
  const hasSummary = summarySources.some(src => {
    if (!src) return false;
    const text = typeof src === 'string' ? src : `${src}`;
    // Treat any non-empty text as summary; don't over-sanitize to avoid false blanks
    return text.trim().length > 0;
  });

  useEffect(() => {
    if (!details?.isResume) {
      resumeConnectAttemptedRef.current = false;
      return;
    }

    if (resumeConnectAttemptedRef.current) return;

    if (!currentMeetingDetails?.fromHistoryResume) return;
    if (!currentMeetingDetails?.parentMeetId) return;
    if (!transScriptSession) return;

    resumeConnectAttemptedRef.current = true;
    connectWebSocket();
  }, [
    details?.isResume,
    currentMeetingDetails?.fromHistoryResume,
    currentMeetingDetails?.parentMeetId,
    transScriptSession,
    connectWebSocket,
  ]);

  useEffect(() => {
    if (!details?.isResume) return;
    if (!currentMeetingDetails?.stopped) return;
    resumeConnectAttemptedRef.current = false;
    resumeMicStartedRef.current = false;
  }, [details?.isResume, currentMeetingDetails?.stopped]);

  useEffect(() => {
    if (!details?.isResume) {
      lastResumeMeetingIdRef.current = null;
      return;
    }
    const nextId = details?.meetingDetails?.id;
    if (!nextId) return;
    if (lastResumeMeetingIdRef.current !== nextId) {
      lastResumeMeetingIdRef.current = nextId;
      resumeConnectAttemptedRef.current = false;
      resumeMicStartedRef.current = false;
    }
  }, [details?.isResume, details?.meetingDetails?.id]);
  const summaryDisabled = isDetailsView
    ? !(isDetailsFull || hasSummary)
    : !hasSummary;
  const getTabButtonSx = (active, disabled) => ({
    textTransform: 'none',
    fontWeight: 400,
    borderRadius: '10px',
    px: 3,
    transition: 'all 0.2s ease',
    bgcolor: active ? 'rgba(179, 209, 250, 0.20)' : 'rgba(235, 238, 242, 0.40)',
    color: active ? 'primary.300' : 'text.primary',
    // border: active ? 'none' : '1px solid var(--grey-200)',
    opacity: disabled && !active ? 0.5 : active ? 1 : 0.8,
    // boxShadow: active ? '0 8px 20px rgba(15, 23, 42, 0.2)' : 'none',
    '&:hover': {
      bgcolor: disabled
        ? active
          ? 'primary.50'
          : 'var(--grey-0)'
        : active
          ? 'primary.50'
          : 'grey.50',
    },
  });
  useEffect(() => {
    if (isHome) {
      setShowSummary(false);
      // Keep summary content if it already exists so Summary tab stays enabled after first run
      if (!hasSummary) {
        setSummaryContext('');
      }
    }
  }, [isHome, hasSummary]);

  // Keep local summary context in sync with the backend/Redux summary once it arrives
  useEffect(() => {
    if (
      summary &&
      !isQuillContentBlank(summary) &&
      (isQuillContentBlank(summaryContext) || !summaryContext)
    ) {
      setSummaryContext(summary);
    }
  }, [summary]);

  // Also sync from Redux summary (for live meeting state) if it appears later
  useEffect(() => {
    if (
      currentMeetingDetails?.summary &&
      !isQuillContentBlank(currentMeetingDetails.summary) &&
      (isQuillContentBlank(summaryContext) || !summaryContext)
    ) {
      setSummaryContext(currentMeetingDetails.summary);
    }
  }, [currentMeetingDetails?.summary, summaryContext]);

  // Auto-scroll to bottom when switching from summary to transcript view
  useEffect(() => {
    // Only scroll when switching from summary (true) to transcript (false)
    if (
      prevShowSummaryRef.current === true &&
      showSummary === false &&
      transcriptContentRef.current
    ) {
      const container = transcriptContentRef.current;
      // Scroll to bottom when switching to transcript view
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
      });
    }
    prevShowSummaryRef.current = showSummary;
  }, [showSummary]);

  // Auto-scroll to bottom when new transcript chunks arrive
  // Use previous scroll state: when content grows, scroll only if user was near bottom *before* the update
  // (after update, scrollHeight increases so "near bottom" would be false with current values)
  useEffect(() => {
    if (showSummary || !transcriptContentRef.current) return;

    const container = transcriptContentRef.current;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    const prevScrollHeight = prevScrollHeightRef.current;
    const prevScrollTop = prevScrollTopRef.current;
    const prevClientHeight = prevClientHeightRef.current;

    const contentGrew = scrollHeight > prevScrollHeight;
    const wasNearBottom =
      prevScrollHeight === 0 ||
      prevScrollHeight - prevScrollTop - prevClientHeight < 100;

    if (contentGrew && wasNearBottom) {
      requestAnimationFrame(() => {
        container.scrollTop = container.scrollHeight;
        prevScrollHeightRef.current = container.scrollHeight;
        prevScrollTopRef.current = container.scrollTop;
        prevClientHeightRef.current = container.clientHeight;
      });
    }

    prevScrollHeightRef.current = scrollHeight;
    prevScrollTopRef.current = scrollTop;
    prevClientHeightRef.current = clientHeight;
  }, [content, showSummary]);
  useEffect(() => {
    if (Object.keys(details).length > 0) {
      fetchMeetingDetails();
    }
  }, [details]);

  // Immediately skip the start screen when resuming from history
  // Note: fromHistoryResume is NOT set here - it's set in fetchMeetingDetails AFTER
  // the API call completes and recordingTime is available. This ensures the WebSocket
  // connects with the correct duration from the previous meeting.
  useEffect(() => {
    if (details?.isResume) {
      setIsHome(false);
      setMeetingAPIDetails({});
      clearMicSpeaker();
      dispatch(resetRecording());
      dispatch(
        setCurrentRecording({
          isStarted: true,
          parentMeetId: details?.meetingDetails?.id,
        })
      );
    }
  }, [
    details?.isResume,
    details?.meetingDetails?.id,
    dispatch,
    setMeetingAPIDetails,
    clearMicSpeaker,
  ]);

  useEffect(() => {
    if (!details?.isResume) {
      resumeMicStartedRef.current = false;
      return;
    }
    if (!websocketConnection) return;
    if (resumeMicStartedRef.current) return;
    if (isMicActive || isSystemActive) return;

    resumeMicStartedRef.current = true;
    startRecording({ useMic: true, useSpeaker: false });
  }, [
    details?.isResume,
    websocketConnection,
    isMicActive,
    isSystemActive,
    startRecording,
  ]);

  // If a meeting is marked as started, ensure we exit the home screen
  useEffect(() => {
    if (isStarted) {
      setIsHome(false);
    }
  }, [isStarted]);
  // const recordingTime = useSelector(
  //   (state) => state.globalRecording.recordingTime
  // );

  // useEffect(() => {
  //   if (transScriptSession && isStarted) {
  //     // connectWebSocket();
  //   }
  // }, [transScriptSession, isStarted]);

  useEffect(() => {
    dispatch(
      setCurrentRecording({
        isRecording: isRecordingHook,
        paused: isPaused,
        // stopped: isStopped,
      })
    );
  }, [isRecordingHook, isPaused]);

  // Reset hasFirstChunk when recording starts or when content is reset
  useEffect(() => {
    if (isRecording && (!content || content.trim().length === 0)) {
      setHasFirstChunk(false);
    }
  }, [isRecording, content]);

  // Set hasFirstChunk to true if content already exists (for resumed meetings or viewing old transcripts)
  useEffect(() => {
    if (content && content.trim().length > 0) {
      setHasFirstChunk(true);
    }
  }, [content]);

  // When meeting has stopped and transcript is empty (e.g. WebSocket closed before final chunks),
  // fetch the recording from API so transcript is visible when the summarize modal opens.
  // Uses progressive delays: 2s, 3s, 4s, 5s, 6s to give the server time to process.
  useEffect(() => {
    if (!stopped || !meeting_id || !transScriptSession) return;
    if (isDetailsView) return; // Viewing from history already has meetingAPIDetails
    const contentEmpty = !content || content.trim().length === 0;
    if (!contentEmpty) return;
    if (lastFetchedMeetingIdForStoppedRef.current === meeting_id) return;
    // Cap at 5 attempts with progressive delays to give server enough time
    if (stoppedTranscriptRetryCountRef.current >= 5) return;

    if (stoppedTranscriptRetryTimerRef.current) {
      clearTimeout(stoppedTranscriptRetryTimerRef.current);
      stoppedTranscriptRetryTimerRef.current = null;
    }
    stoppedTranscriptRetryCountRef.current += 1;
    lastFetchedMeetingIdForStoppedRef.current = meeting_id;
    axios
      .get(`${API_URL}/api/recordings/${meeting_id}`, {
        headers: { Authorization: `Bearer ${transScriptSession}` },
      })
      .then(res => {
        const transcriptText = res.data?.transcript;
        if (transcriptText != null && String(transcriptText).trim()) {
          stoppedTranscriptRetryCountRef.current = 0;
          dispatch(
            setCurrentRecording({
              content: normalizeTranscriptContent(transcriptText),
              transcript: [transcriptText],
            })
          );
        } else {
          // Backend may still be processing; retry with progressive delay
          lastFetchedMeetingIdForStoppedRef.current = null;
          const retryDelay = 1000 + stoppedTranscriptRetryCountRef.current * 1000; // 2s, 3s, 4s, 5s, 6s
          stoppedTranscriptRetryTimerRef.current = setTimeout(() => {
            setStoppedTranscriptRetryTrigger(t => t + 1);
          }, retryDelay);
        }
      })
      .catch(err => {
        lastFetchedMeetingIdForStoppedRef.current = null; // Allow retry
        stoppedTranscriptRetryCountRef.current -= 1;
      });

    return () => {
      if (stoppedTranscriptRetryTimerRef.current) {
        clearTimeout(stoppedTranscriptRetryTimerRef.current);
        stoppedTranscriptRetryTimerRef.current = null;
      }
    };
  }, [
    stopped,
    meeting_id,
    content,
    transScriptSession,
    isDetailsView,
    dispatch,
    stoppedTranscriptRetryTrigger,
  ]);

  // Reset retry count when meeting_id changes so a new meeting can fetch
  useEffect(() => {
    stoppedTranscriptRetryCountRef.current = 0;
  }, [meeting_id]);

  const fetchMeetingDetails = async () => {
    try {
      const includeDeleted = Boolean(
        currentPath.startsWith('/transcribe/bin/meeting/') ||
          details?.includeDeleted ||
          details?.meetingDetails?.isDeleted ||
          details?.meetingDetails?.deleted ||
          details?.meetingDetails?.is_deleted
      );
      const requestConfig = {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
        },
      };
      if (includeDeleted) {
        requestConfig.params = { include_deleted: true };
      }
      axios
        .get(`${API_URL}/api/recordings/${details.meetingDetails.id}`, {
          ...requestConfig,
        })
        .then(res => {
          // Compute startTime from API response when not available from navigation state
          let resolvedStartTime = details.meetingDetails.startTime;
          if (!resolvedStartTime) {
            const apiDate = res.data.date || res.data.start_time || res.data.created_at || res.data.started_at;
            if (apiDate) {
              const dateTime = formatDateTime(apiDate);
              resolvedStartTime = dateTime[1];
            }
          }

          // Backfill startTime into details so the UI can render it
          if (!details.meetingDetails.startTime && resolvedStartTime) {
            setDetails(prev => ({
              ...prev,
              meetingDetails: { ...prev.meetingDetails, startTime: resolvedStartTime },
            }));
          }

          if (details.isResume) {
            const meetingSummary = res.data.mom || '';
            dispatch(
              setCurrentRecording({
                recordingTime: coerceDurationToSeconds(res.data.duration),
                content: normalizeTranscriptContent(res.data.transcript),
                transcript: [res.data.transcript],
                meetingTitle: res.data.title,
                summary: meetingSummary,
                meeting_id: '',
                start_time: resolvedStartTime,
                meetingContext: res.data.meeting_description || '',
                isStarted: true,
                stopped: false,
                parentMeetId: res.data.id,
                fromHistoryResume: true,
              })
            );
            setShowSummary(false);
            setSummaryContext(meetingSummary || '');
          } else {
            setMeetingAPIDetails({
              recordingTime: coerceDurationToSeconds(res.data.duration),
              content: normalizeTranscriptContent(res.data.transcript),
              transcript: [res.data.transcript],
              meetingTitle: res.data.title,
              summary: res.data.mom,
              meeting_id: res.data.id,
              start_time: resolvedStartTime,
              meetingContext: res.data.meeting_description || '',
              isRecording: false,
              isEditingTitle: false,
              paused: false,
              stopped: true,
              micDevice: 'default',
            });
          }
          // );
          if (!details.isResume) {
            const hasMom = res.data.mom && String(res.data.mom).trim();
            if (hasMom || details.meetingDetails.status === 'full') {
              setShowSummary(true);
              setSummaryContext(res.data.mom || '');
            } else {
              setShowSummary(false);
              setSummaryContext('');
            }
          }
          setIsHome(false);
        })
        .catch(() => {});
    } catch (error) {
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while fetching meeting detail.'
        )
      );
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 600);
    }
  };
  const handleTitleEdit = () => {
    // Toggle editing state
    const newEditingState = !isEditingTitle;
    currentTitleRef.current = meetingTitle;
    // Check if we're in details view (else case) - update meetingAPIDetails
    if (
      Object.keys(meetingAPIDetails).length > 0 &&
      details.isDetailsView
    ) {
      setMeetingAPIDetails({
        ...meetingAPIDetails,
        isEditingTitle: newEditingState,
      });
    } else {
      dispatch(setCurrentRecording({ isEditingTitle: newEditingState }));
    }
  };

  const handleTitleSave = () => {
    // Check if we're in details view (else case) - update meetingAPIDetails
    if (
      Object.keys(meetingAPIDetails).length > 0 &&
      details.isDetailsView
    ) {
      setMeetingAPIDetails({
        ...meetingAPIDetails,
        isEditingTitle: false,
      });
    } else {
      dispatch(setCurrentRecording({ isEditingTitle: false }));
    }
    handleTitleUpdate(currentTitleRef);
  };

  const handleTitleBlur = () => {
    // Check if we're in details view (else case) - update meetingAPIDetails
    if (
      Object.keys(meetingAPIDetails).length > 0 &&
      details.isDetailsView
    ) {
      setMeetingAPIDetails({
        ...meetingAPIDetails,
        isEditingTitle: false,
      });
    } else {
      dispatch(setCurrentRecording({ isEditingTitle: false }));
    }
    handleTitleUpdate(currentTitleRef);
  };

  // const handleRecordToggle = () => {
  //     setIsRecording(!isRecording);
  // };
  useEffect(() => {
    if (!audioControlDisabled) {
      if (Object.keys(details).length === 0) {
        if (isRecording) {
          setIsHome(false);
        } else {
          if (stopped) {
            setIsHome(false);
          } else {
            setIsHome(true);
          }
        }
      }
    }
  }, [details, isRecording, stopped, audioControlDisabled]);

  // useEffect(() => {
  //     let interval;

  //     if (isRecording && !hasEnded) {
  //         interval = setInterval(() => {
  //             setRecordingTime((prev) => prev + 1);
  //         }, 1000);
  //     }

  //     return () => clearInterval(interval); // Cleanup
  // }, [isRecording, hasEnded]);

  const enhanceSummaryHtml = htmlString => {
    if (!htmlString) return ''; //Guard clause to prevent errors

    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      const wrapRangeWithStrong = range => {
        const strongEl = doc.createElement('strong');
        try {
          range.surroundContents(strongEl);
        } catch (error) {
          const headingText = range.toString();
          range.deleteContents();
          strongEl.textContent = headingText;
          range.insertNode(strongEl);
        }
        return strongEl;
      };

      const findHeadingRange = li => {
        const walker = doc.createTreeWalker(li, NodeFilter.SHOW_TEXT, null);
        let startNode = null;

        while (walker.nextNode()) {
          const current = walker.currentNode;
          const textValue = current.textContent || '';
          if (!startNode && textValue.trim().length > 0) {
            startNode = current;
          }

          const colonIndex = textValue.indexOf(':');
          if (colonIndex !== -1) {
            const range = doc.createRange();
            range.setStart(startNode || current, 0);
            range.setEnd(current, colonIndex);
            return range;
          }
        }

        return null;
      };

      const ensureHeadingWrapped = li => {
        const existingStrong = li.querySelector(':scope > strong, :scope > b');
        if (existingStrong && /:\s*$/.test(existingStrong.textContent.trim())) {
          return existingStrong;
        }

        const headingRange = findHeadingRange(li);
        if (!headingRange) {
          return null;
        }

        return wrapRangeWithStrong(headingRange);
      };

      const isParentTopic = li => {
        const headingEl =
          li.querySelector(':scope > strong, :scope > b') ||
          ensureHeadingWrapped(li);
        if (!headingEl) {
          return false;
        }
        return /:\s*$/.test((headingEl.textContent || '').trim());
      };

      doc.querySelectorAll('ul').forEach(ul => {
        let currentLi = ul.firstElementChild;

        while (currentLi) {
          ensureHeadingWrapped(currentLi);

          if (
            isParentTopic(currentLi) &&
            !currentLi.querySelector(':scope > ul, :scope > ol')
          ) {
            const nestedList = doc.createElement('ul');
            let sibling = currentLi.nextElementSibling;
            let moved = false;

            while (sibling && sibling.tagName.toLowerCase() === 'li') {
              if (isParentTopic(sibling)) {
                break;
              }
              const nextSibling = sibling.nextElementSibling;
              nestedList.appendChild(sibling);
              sibling = nextSibling;
              moved = true;
            }

            if (moved) {
              currentLi.appendChild(nestedList);
            }
          }

          currentLi = currentLi.nextElementSibling;
        }
      });

      // Convert headings (h1/h2/etc.) to paragraph tags to prevent email clients from using huge fonts
      doc.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(heading => {
        const paragraph = doc.createElement('p');
        paragraph.style.cssText =
          'margin: 0 0 8px; font-weight: 600; font-size: 15px;';
        paragraph.textContent = heading.textContent;
        heading.replaceWith(paragraph);
      });

      // Ensure lists have consistent spacing
      doc.querySelectorAll('ul').forEach(list => {
        list.style.margin = '0 0 8px 16px';
        list.style.padding = '0 0 0 16px';
        list.style.listStyleType = 'disc';
      });

      doc.querySelectorAll('li').forEach(item => {
        item.style.margin = '0 0 4px';
        item.style.fontWeight = '400';
      });

      // Remove empty paragraphs that introduce extra spacing
      doc.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.textContent.trim()) {
          paragraph.remove();
        }
      });

      const rootWrapper = doc.createElement('div');
      rootWrapper.style.cssText =
        "font-family: 'Segoe UI', Arial, sans-serif; font-size: 14px; line-height: 1.5; color: #000;";
      rootWrapper.innerHTML = doc.body.innerHTML.replace(/\n{3,}/g, '\n\n');

      return rootWrapper.outerHTML;
    } catch (error) {
      return htmlString;
    }
  };

  const copySummaryContent = () => {
    const editorElement = document.querySelector('.ql-editor');
    if (!editorElement || !editorElement.innerHTML?.trim()) {
      copy('');
      return false;
    }

    const selection = window.getSelection();
    const previousRange =
      selection.rangeCount > 0 ? selection.getRangeAt(0).cloneRange() : null;

    const range = document.createRange();
    range.selectNodeContents(editorElement);
    selection.removeAllRanges();
    selection.addRange(range);

    const success = document.execCommand('copy');

    selection.removeAllRanges();
    if (previousRange) {
      selection.addRange(previousRange);
    }

    if (!success) {
      copy(editorElement.innerText || '');
    }
    return success;
  };

  const handleCopy = () => {
    let success = true;
    if (showSummary) {
      success = copySummaryContent();
    } else {
      success = copy(transcript || '');
    }
    if (success) {
      dispatch(openSnackbar('success', 'Copied to clipboard!'));
    } else {
      dispatch(openSnackbar('error', 'Failed to copy. Please try again.'));
    }
  };
  // const handleCopy = () => {
  //   const element = document.getElementById("transcript-content"); // Your display element
  //   if (!element) return;

  //   const selection = window.getSelection();
  //   const range = document.createRange();
  //   range.selectNodeContents(element);
  //   selection.removeAllRanges();
  //   selection.addRange(range);

  //   document.execCommand("copy"); // Copies exactly as rendered
  //   selection.removeAllRanges();

  //   setCopied("Copied!");
  //   setTimeout(() => setCopied("Copy"), 2000);
  // };

  // const handleTitleEdit = () => {
  //     setIsEditingTitle(true);
  // };

  // const handleTitleSave = () => {
  //     setIsEditingTitle(false);
  // };

  // const handleTitleBlur = () => {
  //     setIsEditingTitle(false);
  // };

  // const handleRecordToggle = () => {
  //     setIsRecording(!isRecording);
  // };

  const formatTime = totalSeconds => {
    const safeSeconds = coerceDurationToSeconds(totalSeconds);
    // Ensure we're working with a non-negative integer
    const seconds = Math.floor(safeSeconds);
    // 1. Calculate the total number of hours.
    const hours = Math.floor(seconds / 3600);
    // 2. Calculate the remaining minutes after taking out the hours.
    const minutes = Math.floor((seconds % 3600) / 60);
    // 3. Calculate the remaining seconds.
    const secs = seconds % 60;
    // Pad each component with a leading zero if it's a single digit.
    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');
    const paddedSecs = secs.toString().padStart(2, '0');
    return `${paddedHours}:${paddedMinutes}:${paddedSecs}`;
  };

  // PiP functionality - automatically opens when tab changes during recording
  const { 
    isPiPSupported, 
    isPiPOpen, 
    pipWindow, 
    openPiP, 
    closePiP, 
    wasRecentlyManuallyOpened 
  } = useDocumentPiP({
      onClose: ({ fromPagehide } = {}) => {
        // When the PiP window is open it holds focus, not the main document.
        // Chrome's "Back to Tab" explicitly focuses the opener tab BEFORE closing
        // the PiP window and firing pagehide, so document.hasFocus() is true.
        // The "X" button just closes the PiP without focusing the opener first,
        // so document.hasFocus() is false at pagehide time.
        if (fromPagehide && document.hasFocus()) {
          navigate(ROUTES.HOME);
        }
        if (window.focus) {
          window.focus();
        }
      },
      autoOpenOnTabChange: isRecording, // Automatically enable when recording
      // Allow PiP when: (1) recording start — open proactively so PiP is already open when user switches tabs; (2) tab is hidden and recording — so mini PiP shows when user switches tabs even from home; (3) not on home and recording — for proactive open on other routes
      shouldAutoOpen: (context = {}) =>
        (context.recordingStart && isRecording && !stopped) ||
        (context.tabHidden && isRecording && !stopped) ||
        (currentPath !== ROUTES.HOME && isRecording && !stopped),
    });

  // Ensure PiP window is closed whenever the meeting is stopped
  // PiP will persist across navigation (history, deleted meetings, etc.) as long as recording is active
  // This mimics Google Meet's behavior where PiP stays open regardless of which page you're on
  useEffect(() => {
    if (stopped) {
      closePiP();
    }
  }, [stopped, closePiP]);

  // Track if we're on transcript view for PiP logic
  const isTranscriptView = isTranscriptRoute(currentPath);

  // Do not reset PIP preference when navigating to history/bin. If the user closed PiP
  // with the X icon, PiP should only reopen when they click the PiP icon (manual open).

  // Auto-open PiP when navigating away from home route during recording
  // This works with the routing system - PIP should open when navigating to:
  // - History route (/transcribe/history)
  // - Bin route (/transcribe/bin)
  // - Meeting detail routes (/transcribe/meeting/:id or /transcribe/bin/meeting/:id)
  // But NOT on home route (/transcribe/home) when tab is visible
  // Also try to open when switching tabs (via visibility change in hook)
  // PIP state (pipDismissedByUser) persists across navigation via sessionStorage
  useEffect(() => {
    // Only auto-open when:
    // 1. Recording is active
    // 2. Not on home route (PIP should not auto-open on home route when tab is visible)
    // 3. PiP is not already open
    // 4. Not stopped
    if (
      isRecording &&
      isPiPSupported &&
      !isPiPOpen &&
      !stopped &&
      currentPath !== ROUTES.HOME
    ) {
      // Small delay to ensure navigation is complete
      const timer = setTimeout(() => {
        if (isRecording && !isPiPOpen && !stopped && currentPath !== ROUTES.HOME) {
          openPiP({ width: 400, height: 200 }).catch(error => {
            // Silently handle user activation errors - user can manually open via button
            if (
              error.name === 'NotAllowedError' ||
              error.message?.includes('user activation') ||
              error.message?.includes('user gesture')
            ) {
              // PiP auto-open on navigation requires user activation; will try again on tab switch
            }
          });
        }
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [currentPath, isRecording, isPiPSupported, isPiPOpen, stopped, openPiP]);

  // Track tab visibility state
  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsTabHidden(document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Keep PiP open while recording so mini PiP appears when user switches tabs.
  // We do not close PiP when returning to home; PiP content is always rendered so the window is never blank.

  // Handler for closing PiP from UI controls
  // When user explicitly closes PIP from the UI, mark it as dismissed
  const handleClosePiP = () => {
    // Mark as dismissed since this is a user-initiated close
    // The pagehide event will also fire, but this ensures state is updated immediately
    closePiP(true);
  };

  // Handler for expanding PiP (navigating back to home and focusing the main window)
  const handleExpandPiP = () => {
    closePiP();
    navigate(ROUTES.HOME);
    if (window.focus) {
      window.focus();
    }
  };

  // Manual PiP open handler
  // When user clicks PiP on home: open the window now (we have user activation). PiP stays open so when they switch tabs the mini PiP is visible. We do not auto-close when they just manually opened (see close effect above).
  const handleManualOpenPiP = async () => {
    if (!isPiPSupported) return;

    sessionStorage.setItem('pipDismissedByUser', 'false');
    try {
      await openPiP({ width: 400, height: 200, manual: true });
    } catch (error) {
      dispatch(
        openSnackbar(
          'error',
          'Failed to open Picture-in-Picture window. Please check your browser settings.'
        )
      );
    }
  };

  // Handlers for PiP content controls
  const isPipLastActiveSource = (togglingOff, otherActive) =>
    togglingOff && !otherActive && isRecording && !paused;

  const handleMicClick = async () => {
    if (isPipLastActiveSource(isMicActive, isSystemActive)) {
      setPipPendingSourceAction('mic');
      setPipLastSourceDialogOpen(true);
      return;
    }
    await startRecording({
      useMic: !isMicActive,
      useSpeaker: isSystemActive,
    });
  };

  const handleSystemClick = async () => {
    if (isPipLastActiveSource(isSystemActive, isMicActive)) {
      setPipPendingSourceAction('system');
      setPipLastSourceDialogOpen(true);
      return;
    }
    await startRecording({
      useMic: isMicActive,
      useSpeaker: !isSystemActive,
    });
  };

  const handlePipLastSourceProceed = async () => {
    setPipLastSourceDialogOpen(false);
    setPipPendingSourceAction(null);
    await startRecording({
      useMic: false,
      useSpeaker: false,
    });
  };

  const handlePipLastSourceCancel = () => {
    setPipLastSourceDialogOpen(false);
    setPipPendingSourceAction(null);
  };

  const handlePauseClick = () => {
    dispatch(
      setCurrentRecording({
        manualPause: true,
      })
    );
    pauseRecording();
  };

  const handleResume = () => {
    resumeRecording();
  };

  const handleStopClick = async () => {
    const noRecordingExpected = store.getState()?.currentMeetingDetails?.noRecordingExpected;
    dispatch(
      setCurrentRecording({
        stopped: true,
        isRecording: false,
        isStarted: false,
        isFinalizing: !noRecordingExpected,
        lastAutoStopReason: 'manual',
      })
    );
    try {
      await stopRecording();
    } finally {
      clearMicSpeaker();
      if (transScriptSession) {
        dispatch(fetchUserCredits(transScriptSession));
      }
      dispatch(setCurrentRecording({ isFinalizing: false, noRecordingExpected: false }));
    }
  };

  // When stop is clicked from mini PiP: redirect to home immediately so user sees "Finalizing meeting...",
  // then stop the meeting and show summary modal when done.
  const handleStopClickFromPiP = async () => {
    navigate(ROUTES.HOME);
    if (typeof window !== 'undefined' && window.focus) {
      window.focus();
    }
    await handleStopClick();
    dispatch(setCurrentRecording({ shouldOpenSummarizeDialog: true }));
  };

  const handleTitleUpdate = async oldTitle => {
    try {
      const url = `${API_URL}/api`;
      const recording_id = meeting_id;

      // Get the latest meetingTitle from the correct source based on view mode
      let latestMeetingTitle;
      if (
        Object.keys(meetingAPIDetails).length > 0 &&
        details.isDetailsView
      ) {
        // In details view, get from meetingAPIDetails
        latestMeetingTitle =
          meetingAPIDetails?.meetingTitle || meetingTitle;
      } else {
        // Otherwise, get from Redux store
        const currentState = store.getState();
        latestMeetingTitle =
          currentState.currentMeetingDetails?.meetingTitle || meetingTitle;
      }

      if (
        oldTitle.hasOwnProperty('current') &&
        oldTitle.current !== latestMeetingTitle
      ) {
        await axios
          .put(
            `${url}/recordings/${recording_id}`,
            {
              title: latestMeetingTitle,
            },
            {
              headers: {
                Authorization: `Bearer ${transScriptSession}`,
              },
            }
          )
          .then(res => {
            dispatch(openSnackbar('success', 'Meeting Title Updated.'));
            // Update meetingAPIDetails if in details view to keep it in sync
            if (
              Object.keys(meetingAPIDetails).length > 0 &&
              details.isDetailsView
            ) {
              setMeetingAPIDetails({
                ...meetingAPIDetails,
                meetingTitle: latestMeetingTitle,
                isEditingTitle: false, // Ensure editing state is set to false after successful update
              });
            } else {
              // Also ensure editing state is false in Redux store
              dispatch(setCurrentRecording({ isEditingTitle: false }));
            }
          })
          .catch(err => {
            dispatch(
              openSnackbar('error', 'Something Went Wrong Updating Title.')
            );
          });
      }
    } catch (e) {
      dispatch(openSnackbar('error', 'Something Went Wrong.'));
    }
  };
  const handleSumbit = async (
    setDialogOpen,
    isMomUpdate = false,
    updatedSummary = ''
  ) => {
    if (isMomUpdate) {
      if (!updatedSummary || isQuillContentBlank(updatedSummary)) {
        dispatch(openSnackbar('error', "Meeting Summary can't be empty"));
        return;
      }
    }

    setLoading(true);

    // Helper function to wait for meeting_id to be available
    const waitForMeetingId = async (maxWaitTime = 5000) => {
      return new Promise((resolve, reject) => {
        const startTime = Date.now();
        const checkInterval = setInterval(() => {
          const currentState = store.getState();
          const currentMeetingId =
            currentState.currentMeetingDetails.meeting_id || '';

          if (currentMeetingId) {
            clearInterval(checkInterval);
            resolve(currentMeetingId);
          } else if (Date.now() - startTime >= maxWaitTime) {
            clearInterval(checkInterval);
            reject(new Error('Meeting ID not available after waiting'));
          }
        }, 200); // Check every 200ms
      });
    };

    // Get the latest meeting_id from Redux to ensure we have the most up-to-date value
    // This is especially important when resuming from history, as the meeting_id
    // is set by the WebSocket when it receives the new recording_id
    let latestMeetingId = currentMeetingDetails.meeting_id || meeting_id;

    // If meeting_id is missing (especially when resuming from history), wait for it
    if (!latestMeetingId) {
      try {
        // Wait up to 5 seconds for the meeting_id to be set by WebSocket
        latestMeetingId = await waitForMeetingId(5000);
      } catch (error) {
        // If still not available, try to fetch it from the history API
        // When resuming, the server creates a new child recording
        // We need to find the latest child recording for this parent
        if (
          currentMeetingDetails.parentMeetId &&
          currentMeetingDetails.fromHistoryResume
        ) {
          try {
            // Get today's date range to search for recent recordings
            const today = new Date();
            const startDate = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate()
            );
            const endDate = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate() + 1
            );

            const formatDate = date => {
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            };

            // Query history API to find child recordings
            const historyResponse = await axios.get(
              `${API_URL}/api/history?start_date=${formatDate(startDate)}&end_date=${formatDate(endDate)}`,
              {
                headers: {
                  Authorization: `Bearer ${transScriptSession}`,
                },
              }
            );

            // Find the latest child recording that has this parent as parent_recording_id
            if (historyResponse.data && Array.isArray(historyResponse.data)) {
              const childRecordings = historyResponse.data.filter(
                recording =>
                  recording.parent_recording_id ===
                  currentMeetingDetails.parentMeetId
              );

              if (childRecordings.length > 0) {
                // Sort by date/id to get the latest one
                childRecordings.sort((a, b) => {
                  const dateA = new Date(a.date || a.created_at || 0);
                  const dateB = new Date(b.date || b.created_at || 0);
                  return dateB - dateA; // Latest first
                });

                latestMeetingId = childRecordings[0].id;
                // Update Redux with the meeting_id
                dispatch(setCurrentRecording({ meeting_id: latestMeetingId }));
              } else {
                // No child recording found yet, use parentMeetId as fallback
                // The server should handle creating/using the appropriate recording
                latestMeetingId = currentMeetingDetails.parentMeetId;
              }
            } else {
              // Last resort: use parentMeetId
              latestMeetingId = currentMeetingDetails.parentMeetId;
            }
          } catch (apiError) {
            // Last resort: use parentMeetId (server should handle this)
            latestMeetingId = currentMeetingDetails.parentMeetId;
          }
        }

        // If still no meeting_id, show error
        if (!latestMeetingId) {
          setLoading(false);
          dispatch(
            openSnackbar(
              'error',
              'Meeting ID is missing. Please wait a moment and try again, or refresh the page.'
            )
          );
          return;
        }
      }
    }

    const url = `${API_URL}/api`;
    const recording_id = latestMeetingId;
    try {
      var momUrl = `${url}/generate-mom`;
      var payload = {
        recording_id: recording_id,
        meeting_description: currentMeetingDetails.meetingContext,
      };
      var method = 'post';
      if (isMomUpdate) {
        momUrl = `${url}/recordings/${recording_id}/mom`;
        payload = {
          mom: updatedSummary,
        };
        method = 'put';
      }

      dispatch(setCurrentRecording({ meetingContext: '' }));
      await axios[method](momUrl, payload, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
        },
      })
        .then(res => {
          if (method === 'post') {
            dispatch(setCurrentRecording({ meetingContext: '' }));
            setSummaryContext(res.data.minutes);
            dispatch(
              openSnackbar('success', 'Meeting Summary generated successfully.')
            );
          } else {
            dispatch(openSnackbar('success', 'Meeting Summary Updated.'));
          }
          if (setDialogOpen && !isMomUpdate) {
            setDialogOpen(false);
            setShowSummary(true);
          }
        })
        .catch(err => {
          const errorMessage =
            err.response?.data?.message ||
            err.response?.data?.error ||
            err.message ||
            'Something went wrong for minutes of meeting.';
          dispatch(openSnackbar('error', errorMessage));
        });
    } catch (error) {
      dispatch(
        openSnackbar('error', 'Something went wrong for minutes of meeting.')
      );
    } finally {
      setLoading(false);
    }
  };
const isMobileView = isMobile || isTablet;
const isPhoneView = isMobile && !isTablet;
const showMobileStartTime =
  Object.keys(details || {}).length > 0 &&
  !details?.isResume &&
  details?.meetingDetails?.startTime;

  // Share functionality handlers
  const handleShareClick = async (event) => {
    event?.stopPropagation?.();
    setIsLoadingShare(true);
    setOpenShareDialog(true);

    try {
      const recordingId = meetingAPIDetails?.id || details?.meetingDetails?.id;

      if (!recordingId) {
        dispatch(
          openSnackbar(
            'error',
            'Unable to share this meeting. Meeting ID is missing.'
          )
        );
        setOpenShareDialog(false);
        return;
      }

      const response = await axios.post(
        `${API_URL}/api/share`,
        {
          recording_id: recordingId,
        },
        {
          headers: {
            Authorization: `Bearer ${transScriptSession}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data && response.data.url) {
        setShareUrl(response.data.url);
      } else {
        dispatch(openSnackbar('error', 'Failed to generate share URL.'));
        setOpenShareDialog(false);
      }
    } catch (error) {
      dispatch(
        openSnackbar(
          'error',
          error.response?.data?.message ||
            'Something went wrong while sharing meeting.'
        )
      );
      setOpenShareDialog(false);
    } finally {
      setIsLoadingShare(false);
    }
  };

  const handleShareDialogClose = () => {
    setOpenShareDialog(false);
    setShareUrl('');
    setShareCopied(false);
  };

  const handleCopyShareUrl = () => {
    if (shareUrl) {
      const copySuccess = copy(shareUrl);
      if (copySuccess) {
        setShareCopied(true);
        dispatch(openSnackbar('success', 'URL copied to clipboard!'));
        setTimeout(() => setShareCopied(false), 2000);
      } else {
        dispatch(openSnackbar('error', 'Failed to copy URL.'));
      }
    }
  };

  const gmailLink = shareUrl
    ? `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Meeting%20Recording&body=${encodeURIComponent(`Hey, take a look at this:\n\n${shareUrl}`)}`
    : '';

const renderActionIcons = () => (
  <>
    {isPiPSupported && isRecording && (
      <Tooltip
        title={
          isPiPOpen
            ? 'Picture-in-Picture is open'
            : currentPath === ROUTES.HOME
              ? 'Open Picture-in-Picture on another page'
              : 'Open Picture-in-Picture'
        }
        arrow
      >
        <span>
          <IconButton
            onClick={handleManualOpenPiP}
            disabled={isPiPOpen}
            sx={{
              color: isPiPOpen ? 'primary.main' : 'text.primary',
              padding: isMobile ? '4px' : '8px',
            }}
          >
            <PictureInPictureAlt />
          </IconButton>
        </span>
      </Tooltip>
    )}

    {/* Auto-pause toggle (mobile view) - hidden when Silero VAD is disabled */}
    {/* {isRecording && !stopped && (
      <Tooltip
        title={vadEnabled !== false ? 'Disable auto-pause' : 'Enable auto-pause'}
        arrow
      >
        <span>
          <IconButton
            size="small"
            onClick={() => {
              dispatch(
                setCurrentRecording({
                  vadEnabled: !vadEnabled,
                })
              );
            }}
            disabled={audioControlDisabled}
            sx={{
              color: vadEnabled !== false ? 'primary.main' : 'text.disabled',
              opacity: vadEnabled !== false ? 1 : 0.5,
              border: '1px solid',
              borderColor: 'bluegrey.200',
              borderRadius: 1,
              mr: 0.5,
            }}
          >
            <ResumeIconNew fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    )} */}

    {/* Share button - mobile view only when coming from history (details view), not when from recycle bin */}
    {isMobileView && isDetailsView && !currentPath.startsWith('/transcriber/bin/meeting/') && (
      <Tooltip title="Share" arrow>
        <IconButton
          size="small"
          onClick={handleShareClick}
          sx={{
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'bluegrey.200',
            borderRadius: 1,
            mr: 0.5,
          }}
        >
          <ShareOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    )}

    <Tooltip title="Copy Content" arrow>
      <IconButton
        size="small"
        onClick={() => {
          handleCopy();
        }}
        sx={{
          color: 'text.primary',
          border: '1px solid',
          borderColor: 'bluegrey.200',
          borderRadius: 1,
        }}
      >
        <ContentCopy fontSize="small" />
      </IconButton>
    </Tooltip>
  </>
);
const messages = [
  "Processing audio now..",
  "Finalizing transcript output..",
  "Applying final checks..",
  "Almost there now..",
  "Saving final version..",
];
return (
    <>
      <Backdrop
        open={Boolean(currentMeetingDetails?.isFinalizing)}
        sx={{
          color: '#fff',
          backgroundColor:'#000000b8',
          zIndex: theme => theme.zIndex.drawer + 1,
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <RotatingText
          text={messages}
          duration={2500}
          sx={{
            // Container styles
            minWidth: "300px", // Keeps the box size stable
            textAlign: "center",
          }}
          typographyProps={{
            // Font styles
            variant: "12px",
            fontWeight: "400",
            sx: {
              color: "white",
            },
          }}
        />
        {/* <Typography variant="body1" component="span">
          Finalizing meeting…
        </Typography> */}
      </Backdrop>
      <Stack
        spacing={0}
        sx={{ position: 'relative', minHeight: '100%', width: '100%' }}
      >
        {isHome ? (
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            height={'100%'}
            maxWidth={'100%'}
            textAlign={'center'}
            p={2}
          >
            {/* Hide start UI on mobile view */}
            {!isMobileView && (
              <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                gap={2}
                width={'100%'}
                margin={'0 auto'}
              >
                <img
                  src={TranscriptionImg}
                  style={{ minWidth: '380px', maxWidth: '100%' }}
                />
                {(isLoadingCredits || !isDisabled) && (
                  <Typography
                    variant="subtitle1"
                    color={'grey.500'}
                    fontWeight={400}
                    lineHeight={'normal'}
                  >
                    Click{' '}
                    <Link
                      // --- 3. APPLY DISABLE LOGIC TO THE LINK ---
                      component="button" // Render as a button for disabled property
                      disabled={isDisabled}
                      sx={{
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                        opacity: isDisabled ? 0.6 : 1,
                        // Add styles to make it look like a link
                        border: 'none',
                        background: 'none',
                        padding: 0,
                        font: 'inherit',
                        textDecoration: 'none',
                        verticalAlign: 'baseline',
                      }}
                      onClick={() => {
                        if (isDisabled) return; // Prevent action if disabled
                        setIsHome(false);
                        setMeetingAPIDetails({});
                        dispatch(resetRecording());
                        resetAll();
                        clearMicList();
                        setTimeout(() => {
                          dispatch(setCurrentRecording({ isStarted: true }));
                        }, 800);
                      }}
                    >
                      <Typography
                        component="span"
                        color="primary.300"
                        sx={{ textDecoration: 'underline' }}
                      >
                        {isLoadingCredits ? 'Loading...' : 'Start'}
                      </Typography>
                    </Link>{' '}
                    to activate the meeting transcription.
                  </Typography>
                )}

                {/* API error state */}
                {(credits === null || creditsStatus === 'failed') &&
                  !isLoadingCredits && (
                    <Typography
                      variant="subtitle1"
                      color="error"
                      fontWeight={400}
                      lineHeight="normal"
                    >
                      Something went wrong while fetching your credits. Please try
                      again later.
                    </Typography>
                  )}

                {/* Show out of credits message only if loading is complete and credits are not available */}
                {!isLoadingCredits &&
                  isDisabled &&
                  credits !== null &&
                  creditsStatus !== 'failed' && (
                    <Typography
                      variant="subtitle1"
                      color="error"
                      fontWeight={400}
                      lineHeight="normal"
                    >
                      You have run out of credits. Transcription will stop.
                    </Typography>
                  )}
                <Box
                  sx={{
                    borderRadius: '10px',
                    border: '1px solid var(--grey-200)',
                    background: 'rgba(246, 248, 251, 0.60)',
                    px: 2,
                    py: 1.7,
                  }}
                >
                  <Button
                    disabled={isDisabled}
                    variant="contained"
                    startIcon={
                      <PlayCircleIcon
                        sx={{
                          fontSize: 24,
                          color: isDisabled
                            ? 'rgba(0, 0, 0, 0.26)'
                            : 'var(--primary-300)',
                        }}
                      />
                    }
                    onClick={() => {
                      if (isDisabled) return;
                      setIsHome(false);
                      setMeetingAPIDetails({});
                      dispatch(resetRecording());
                      resetAll();
                      clearMicList();
                      setTimeout(() => {
                        dispatch(setCurrentRecording({ isStarted: true }));
                      }, 800);
                    }}
                    sx={{
                      bgcolor: 'rgba(179, 209, 250, 0.30)',
                      color: 'var(--primary-300)',
                      textTransform: 'none',
                      borderRadius: 2.5,
                      px: 1.5,
                      py: 1,
                      '&:hover': {
                        bgcolor: 'rgba(179, 209, 250, 0.60)',
                        boxShadow: 'none',
                      },
                      '&.Mui-disabled': {
                        bgcolor: 'rgba(0, 0, 0, 0.12)',
                        color: 'rgba(0, 0, 0, 0.26)',
                      },
                    }}
                  >
                    {isLoadingCredits ? 'Loading...' : 'Start'}
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        ) : (
          // <>
          //   <Box
          //     className="page-header"
          //     sx={{
          //       position: 'sticky',
          //       top: 0,
          //       zIndex: 10,
          //       backgroundColor: 'white',
          //       display: 'flex',
          //       alignItems: 'center',
          //       justifyContent: 'space-between',
          //       borderBottom: '1px solid var(--grey-200)',
          //       padding: '16px 16px 0 16px',
          //     }}
          //     maxHeight={'60px'}
          //   >
          //     <Box
          //       sx={{
          //         borderRadius: '100px',
          //         border: 'solid 1px var(--primary-300)',
          //         position: 'absolute',
          //         left: '50%',
          //         bottom: '-15px',
          //         transform: 'translateX(-50%)',
          //         zIndex: 1,
          //         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
          //       }}
          //     >
          //       {/* {isRecording && ( */}
          //       <>
          //         <Chip
          //           icon={
          //             <AccessTime
          //               sx={{ color: 'var(--primary-300) !important' }}
          //             />
          //           }
          //           label={formatTime(recordingTime)}
          //           size="medium"
          //           sx={{
          //             backgroundColor: 'primary.50',
          //             color: 'primary.dark',
          //             fontWeight: 600,
          //             fontSize: '16px',
          //           }}
          //         />
          //       </>
          //       {/* )} */}
          //     </Box>

          //     <MeetingTitle
          //       meetingTitle={meetingTitle}
          //       isEditingTitle={isEditingTitle}
          //       setIsEditingTitle={setIsEditingTitle}
          //       // setMeetingTitle={setMeetingTitle}
          //       setMenuSeleted={navigate}
          //       details={details}
          //       handleTitleSave={handleTitleSave}
          //       meeting_id={meeting_id}
          //       handleTitleEdit={handleTitleEdit}
          //       handleTitleBlur={handleTitleBlur}
          //       setShowSummary={setShowSummary}
          //       isDetailsView={
          //         Object.keys(meetingAPIDetails).length > 0 &&
          //         details.isDetailsView
          //       }
          //       setMeetingAPIDetails={setMeetingAPIDetails}
          //       meetingAPIDetails={meetingAPIDetails}
          //     />
          //     <Box
          //       sx={{
          //         display: 'flex',
          //         alignItems: 'center',
          //         gap: 1,
          //       }}
          //     >
          //       {/* PiP Button - Only show when recording and PiP is supported */}
                // {isPiPSupported && isRecording && (
                //   <Tooltip
                //     title={
                //       isPiPOpen
                //         ? 'Picture-in-Picture is open'
                //         : 'Open Picture-in-Picture'
                //     }
                //     arrow
                //   >
                //     <span>
                //       <IconButton
                //         onClick={handleManualOpenPiP}
                //         disabled={isPiPOpen}
                //         sx={{
                //           color: isPiPOpen ? 'primary.main' : 'text.primary',
                //         }}
                //       >
                //         <PictureInPictureAlt />
                //       </IconButton>
                //     </span>
                //   </Tooltip>
                // )}
          //       <Tooltip title="Copy Content" arrow>
          //         <IconButton
          //           onClick={() => {
          //             handleCopy();
          //           }}
          //         >
          //           <ContentCopy />
          //         </IconButton>
          //       </Tooltip>
          //       {/* Desktop Buttons */}
          //       <Stack
          //         direction="row"
          //         spacing={1}
          //         display={{ xs: 'flex', md: 'flex' }}
          //       >
          //         <Button
          //           variant="contained"
          //           startIcon={<Assignment />}
          //           // disabled={
          //           //   Object.keys(details).length > 0 &&
          //           //   details.isDetailsView
          //           //     ? false
          //           //     : showSummary
          //           // }
          //           // details.meetingDetails.status
          //           sx={getTabButtonSx(!showSummary, false)}
          //           onClick={() => {
          //             if (showSummary) {
          //               setShowSummary(false);
          //             }
          //           }}
          //         >
          //           Transcript
          //         </Button>
          //         <Button
          //           variant="contained"
          //           startIcon={<GenieIconNew />}
          //           // disabled={!showSummary}
          //           disabled={summaryDisabled}
          //           sx={getTabButtonSx(showSummary, summaryDisabled)}
          //           onClick={() => {
          //             if (
          //               (Object.keys(details).length > 0 &&
          //                 details.isDetailsView) ||
          //               currentMeetingDetails.stopped
          //             ) {
          //               setShowSummary(true);
          //             }
          //           }}
          //         >
          //           Summary
          //         </Button>
          //       </Stack>
          //       {/* Mobile Buttons */}
          //       {/* <Stack
          //         direction="row"
          //         spacing={1}
          //         display={{ xs: "flex", md: "none" }}
          //       >
          //         <Tooltip title="Transcript" arrow>
          //           <IconButton
          //             sx={
          //               Object.keys(details).length > 0 &&
          //               details.isDetailsView
          //                 ? {
          //                     opacity: showSummary ? 0.5 : 1,
          //                   }
          //                 : {}
          //             }
          //             onClick={() => {
          //               if (showSummary) {
          //                 setShowSummary(false);
          //               }
          //             }}
          //           >
          //             <Assignment />
          //           </IconButton>
          //         </Tooltip>
          //         <Tooltip title="Summary" arrow>
          //           <IconButton
          //             disabled={
          //               Object.keys(details).length > 0 &&
          //               details.isDetailsView
          //                 ? details.meetingDetails.status !== "full"
          //                 : summaryContext.length === 0 &&
          //                   isQuillContentBlank(summaryContext)
          //             }
          //             // disabled={!showSummary}
          //             sx={
          //               Object.keys(details).length > 0 &&
          //               details.isDetailsView
          //                 ? {
          //                     opacity: showSummary ? 1 : 0.5,
          //                   }
          //                 : {}
          //             }
          //             onClick={() => {
          //               if (
          //                 (Object.keys(details).length > 0 &&
          //                   details.isDetailsView) ||
          //                 currentMeetingDetails.stopped
          //               ) {
          //                 setShowSummary(true);
          //               }
          //             }}
          //           >
          //             <GenieIconNew />
          //           </IconButton>
          //         </Tooltip>
          //       </Stack> */}
          //     </Box>
          //   </Box>

          //   {/* transcribe content  */}
          //   <Box
          //     ref={transcriptContentRef}
          //     className="main-content"
          //     //contentEditable={false}
          //     //suppressContentEditableWarning={true}
          //     sx={{
          //       padding: '0px 16px 16px 16px',
          //       mt: '24px',
          //       overflowY: 'auto',
          //       flex: '1 1 auto',
          //       '& .MuiTypography-root': {
          //         color: 'text.primary',
          //       },
          //     }}
          //     id="transcript-content"
          //   >
          //     {/* {transcript.map(data =>  */}
          //     {showSummary ? (
          //       <MeetingMinutesEditor
          //         summaryContext={summaryContext}
          //         setSummaryContext={setSummaryContext}
          //         handleSumbit={handleSumbit}
          //         markdownToQuill={markdownToQuill}
          //       />
          //     ) : (
          //       <>
          //         {!hasFirstChunk && isRecording ? (
          //           <Box
          //             sx={{
          //               display: 'flex',
          //               justifyContent: 'center',
          //               alignItems: 'center',
          //               minHeight: '200px',
          //               flexDirection: 'column',
          //               gap: 2,
          //             }}
          //           >
          //             <dotlottie-wc
          //               src="https://lottie.host/b3ac8f7e-464c-4020-bead-8b7e5fa5bc7b/jDjttWIswh.lottie"
          //               style={{ width: '500px', height: '500px' }}
          //               autoplay
          //               loop
          //             ></dotlottie-wc>
          //           </Box>
          //         ) : (
          //           <Typography
          //             variant="body2"
          //             component="div"
          //             sx={{ mb: '10px' }}
          //             dangerouslySetInnerHTML={{ __html: content || '' }}
          //           />
          //         )}
          //       </>
          //     )}

          //     {/* )} */}
          //   </Box>
          //   <Box
          //     sx={{
          //       position: 'sticky',
          //       bottom: 0,
          //       zIndex: 10,
          //       backgroundColor: 'white',
          //       padding: '16px',
          //     }}
          //   >
          //     {/* <IconButton
          //       size="small"
          //       onClick={handleOpenPiP}
          //       disabled={isPiPOpen}
          //     >
          //       <PictureInPictureAltIcon />
          //     </IconButton>
          //     <IconButton
          //       size="small"
          //       onClick={() => setIsAutoPiPEnabled((prev) => !prev)}
          //       className={isAutoPiPEnabled ? "enabled" : ""}
          //     >
          //       {isAutoPiPEnabled ? (
          //         <PictureInPictureAltIcon />
          //       ) : (
          //         <PictureInPictureIcon />
          //       )}
          //     </IconButton> */}
          //     <AudioControl
          //       setDetails={setDetails}
          //       startRecording={startRecording}
          //       stopRecording={stopRecording}
          //       isRecording={isRecording}
          //       pauseRecording={pauseRecording}
          //       setShowSummary={setShowSummary}
          //       handleSumbit={handleSumbit}
          //       showSummary={showSummary}
          //       setLoading={setLoading}
          //       loading={loading}
          //       handleTitleUpdate={handleTitleUpdate}
          //       setMeetingAPIDetails={setMeetingAPIDetails}
          //       transScriptSession={transScriptSession}
          //       meetingAPIDetails={meetingAPIDetails}
          //       details={details}
          //       isViewDetails={
          //         !(
          //           (Object.keys(details).length > 0 &&
          //             details.isResume) ||
          //           !(Object.keys(details).length > 0)
          //         )
          //       }
          //       resumeRecording={resumeRecording}
          //       streamRef={streamRef}
          //       isHome={isHome}
          //       resetTimer={resetTimer}
          //       setMenuSeleted={navigate}
          //       setSummaryContext={setSummaryContext}
          //       summaryContext={summaryContext}
          //       microphones={microphones}
          //       activeMicrophone={activeMicrophone}
          //       volume={volume}
          //       microphoneError={microphoneError}
          //       selectMicrophone={selectMicrophone}
          //       isMicActive={isMicActive}
          //       isSystemActive={isSystemActive}
          //       clearMicSpeaker={clearMicSpeaker}
          //       resetAll={resetAll}
          //       currentPath={currentPath}
          //     />

          //     {/* PiP Window Content */}
          //     {pipWindow && (
          //       <DocumentPiP pipWindow={pipWindow}>
          //         <PiPContent
          //           meetingTitle={meetingTitle}
          //           recordingTime={recordingTime}
          //           isRecording={isRecording}
          //           paused={paused}
          //           isMicActive={isMicActive}
          //           isSystemActive={isSystemActive}
          //           volume={volume}
          //           activeMicrophone={activeMicrophone}
          //           microphones={microphones}
          //           onMicClick={handleMicClick}
          //           onSystemClick={handleSystemClick}
          //           onPauseClick={handlePauseClick}
          //           onResumeClick={handleResume}
          //           onStopClick={handleStopClick}
          //           onClose={handleClosePiP}
          //           onExpand={handleExpandPiP}
          //           selectMicrophone={selectMicrophone}
          //           streamRef={streamRef}
          //         />
          //       </DocumentPiP>
          //     )}
          //   </Box>
          // </>
            <>

              {/* =========================================================
                DESKTOP VIEW (Original Layout)
               ========================================================= */}
              {!isMobileView && (
                <>
                  <Box
                    className="page-header"
                    sx={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 10,
                      backgroundColor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      borderBottom: '1px solid var(--grey-200)',
                      padding: '8px 16px 7px 16px',
                    }}
                    maxHeight={'60px'}
                  >
                    <Box
                      sx={{
                        borderRadius: '100px',
                        border: 'solid 1px var(--primary-300)',
                        position: 'absolute',
                        left: '50%',
                        bottom: '-15px',
                        transform: 'translateX(-50%)',
                        zIndex: 1,
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                        '@media (max-width: 1144px) and (min-width: 768px)': {
                          bottom: '-29px',
                        },
                      }}
                    >
                      {/* {isRecording && ( */}
                      <>
                        <Chip
                          icon={
                            <AccessTime
                              sx={{ color: 'var(--primary-300) !important' }}
                            />
                          }
                          label={formatTime(recordingTime)}
                          size="medium"
                          sx={{
                            backgroundColor: 'primary.50',
                            color: 'primary.dark',
                            fontWeight: 600,
                            fontSize: '16px',
                          }}
                        />
                      </>
                      {/* )} */}
                    </Box>

                    <MeetingTitle
                      meetingTitle={meetingTitle}
                      isEditingTitle={isEditingTitle}
                      setIsEditingTitle={setIsEditingTitle}
                      // setMeetingTitle={setMeetingTitle}
                      setMenuSeleted={navigate}
                      details={details}
                      handleTitleSave={handleTitleSave}
                      meeting_id={meeting_id}
                      handleTitleEdit={handleTitleEdit}
                      handleTitleBlur={handleTitleBlur}
                      setShowSummary={setShowSummary}
                      isDetailsView={
                        Object.keys(meetingAPIDetails).length > 0 &&
                        details.isDetailsView
                      }
                      setMeetingAPIDetails={setMeetingAPIDetails}
                      meetingAPIDetails={meetingAPIDetails}
                    />
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                      }}
                    >
                      {/* PiP Button - Only show when recording and PiP is supported */}
                      {isPiPSupported && isRecording && (
                        <Tooltip
                          title={
                            isPiPOpen
                              ? 'Picture-in-Picture is open (click to reset dismissal)'
                              : currentPath === ROUTES.HOME
                                ? 'Open Picture-in-Picture on another page'
                                : 'Open Picture-in-Picture'
                          }
                          arrow
                        >
                          <span>
                            <IconButton
                              onClick={handleManualOpenPiP}
                              sx={{
                                color: isPiPOpen
                                  ? 'primary.main'
                                  : 'text.primary',
                              }}
                            >
                              <PictureInPictureAlt />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )}
                      {/* Disable auto-pause button - hidden when Silero VAD is disabled */}
                      {/* {isRecording && !stopped && (
                        <Tooltip 
                          title={vadEnabled !== false ? "Disable auto-pause" : "Enable auto-pause"} 
                          arrow
                        >
                          <span>
                            <IconButton
                              onClick={() => {
                                dispatch(
                                  setCurrentRecording({
                                    vadEnabled: !vadEnabled,
                                  })
                                );
                              }}
                              disabled={audioControlDisabled}
                              sx={{
                                color: vadEnabled !== false ? 'primary.main' : 'text.disabled',
                                opacity: vadEnabled !== false ? 1 : 0.5,
                              }}
                            >
                              <ResumeIconNew />
                            </IconButton>
                          </span>
                        </Tooltip>
                      )} */}
                      <Tooltip title="Copy Content" arrow>
                        <IconButton
                          onClick={() => {
                            handleCopy();
                          }}
                        >
                          <ContentCopy />
                        </IconButton>
                      </Tooltip>
                      {/* Desktop Buttons */}
                      <Stack
                        direction="row"
                        spacing={1}
                        display={{ xs: 'flex', md: 'flex' }}
                      >
                        <Button
                          variant="contained"
                          startIcon={<Assignment />}
                          // disabled={
                          //   Object.keys(details).length > 0 &&
                          //   details.isDetailsView
                          //     ? false
                          //     : showSummary
                          // }
                          // details.meetingDetails.status
                          sx={getTabButtonSx(!showSummary, false)}
                          onClick={() => {
                            if (showSummary) {
                              setShowSummary(false);
                            }
                          }}
                        >
                          Transcript
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<GenieIconNew />}
                          // disabled={!showSummary}
                          disabled={summaryDisabled}
                          sx={{
                            ...getTabButtonSx(showSummary, summaryDisabled),
                            '&.Mui-disabled': {
                              color: 'grey.700',
                            },

                          }}
                          onClick={() => {
                            if (
                              (Object.keys(details).length > 0 &&
                                details.isDetailsView) ||
                              currentMeetingDetails.stopped
                            ) {
                              setShowSummary(true);
                            }
                          }}
                        >
                          Summary
                        </Button>
                      </Stack>
                      {/* Mobile Buttons */}
                      {/* <Stack
                  direction="row"
                  spacing={1}
                  display={{ xs: "flex", md: "none" }}
                >
                  <Tooltip title="Transcript" arrow>
                    <IconButton
                      sx={
                        Object.keys(details).length > 0 &&
                        details.isDetailsView
                          ? {
                              opacity: showSummary ? 0.5 : 1,
                            }
                          : {}
                      }
                      onClick={() => {
                        if (showSummary) {
                          setShowSummary(false);
                        }
                      }}
                    >
                      <Assignment />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Summary" arrow>
                    <IconButton
                      disabled={
                        Object.keys(details).length > 0 &&
                        details.isDetailsView
                          ? details.meetingDetails.status !== "full"
                          : summaryContext.length === 0 &&
                            isQuillContentBlank(summaryContext)
                      }
                      // disabled={!showSummary}
                      sx={
                        Object.keys(details).length > 0 &&
                        details.isDetailsView
                          ? {
                              opacity: showSummary ? 1 : 0.5,
                            }
                          : {}
                      }
                      onClick={() => {
                        if (
                          (Object.keys(details).length > 0 &&
                            details.isDetailsView) ||
                          currentMeetingDetails.stopped
                        ) {
                          setShowSummary(true);
                        }
                      }}
                    >
                      <GenieIconNew />
                    </IconButton>
                  </Tooltip>
                </Stack> */}
                    </Box>
                  </Box>

               {/* transcribe content  */}
            <Box
              ref={transcriptContentRef}
              className="main-content"
              // display={'flex'}
              // justifyContent={'center'}
              //contentEditable={false}
              //suppressContentEditableWarning={true}
              sx={{
                padding: '0px 16px 16px 16px',
                mt: '24px',
                overflowY: 'auto',
                flex: '1 1 auto',
                '& .MuiTypography-root': {
                  color: 'text.primary',
                },
              }}
              id="transcript-content"
            >
              {/* On home when PiP is open (user clicked PiP button), show empty state; when PiP closes, show previous content */}
              {currentPath === ROUTES.HOME && isPiPOpen ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 'calc(100vh - 320px)',
                    width: '100%',
                  }}
                >
                  <PiPEmptyStateSvg
                    width="100%"
                    height="auto"
                    style={{ maxWidth: 660, minHeight: 280 }}
                  />
                </Box>
              ) : (
                <>
                  {/* Keep both components mounted to preserve state when switching tabs */}
                  <Box
                    sx={{
                      display: showSummary ? 'block' : 'none',
                      height: '100%',
                    }}
                  >
                    <MeetingMinutesEditor
                      summaryContext={summaryContext}
                      setSummaryContext={setSummaryContext}
                      handleSumbit={handleSumbit}
                      markdownToQuill={markdownToQuill}
                    />
                  </Box>
                  <Box
                    sx={{
                      display: showSummary ? 'none' : 'block',
                    }}
                  >
                    {!hasFirstChunk && isRecording ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          minHeight: 'calc(100vh - 400px)',
                          flexDirection: 'column',
                          gap: 2,
                        }}
                      >
                        <LoadingCogSvg width={400} height={300} />
                      </Box>
                    ) : (
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{ mb: '10px' }}
                        dangerouslySetInnerHTML={{ __html: content || '' }}
                      />
                    )}
                  </Box>
                </>
              )}
            </Box>
                  <Box
                    sx={{
                      position: 'sticky',
                      bottom: 0,
                      zIndex: 10,
                      backgroundColor: 'white',
                      padding: '16px',
                      // Hide mini bar on home when PIP is open (user opened PIP via button)
                      ...(currentPath === ROUTES.HOME && isPiPOpen && { display: 'none' }),
                    }}
                  >
                    {/* <IconButton
                size="small"
                onClick={handleOpenPiP}
                disabled={isPiPOpen}
              >
                <PictureInPictureAltIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => setIsAutoPiPEnabled((prev) => !prev)}
                className={isAutoPiPEnabled ? "enabled" : ""}
              >
                {isAutoPiPEnabled ? (
                  <PictureInPictureAltIcon />
                ) : (
                  <PictureInPictureIcon />
                )}
              </IconButton> */}
              <AudioControl
                setDetails={setDetails}
                startRecording={startRecording}
                stopRecording={stopRecording}
                isRecording={isRecording}
                pauseRecording={pauseRecording}
                setShowSummary={setShowSummary}
                handleSumbit={handleSumbit}
                showSummary={showSummary}
                setLoading={setLoading}
                loading={loading}
                handleTitleUpdate={handleTitleUpdate}
                setMeetingAPIDetails={setMeetingAPIDetails}
                transScriptSession={transScriptSession}
                meetingAPIDetails={meetingAPIDetails}
                details={details}
                isViewDetails={
                  !(
                    (Object.keys(details).length > 0 &&
                      details.isResume) ||
                    !(Object.keys(details).length > 0)
                  )
                }
                resumeRecording={resumeRecording}
                streamRef={streamRef}
                isHome={isHome}
                resetTimer={resetTimer}
                setMenuSeleted={navigate}
                setSummaryContext={setSummaryContext}
                summaryContext={summaryContext}
                hasSummary={hasSummary}
                microphones={microphones}
                activeMicrophone={activeMicrophone}
                volume={volume}
                microphoneError={microphoneError}
                selectMicrophone={selectMicrophone}
                isMicActive={isMicActive}
                isSystemActive={isSystemActive}
                clearMicSpeaker={clearMicSpeaker}
                resetAll={resetAll}
                currentPath={currentPath}
              />

              {/* PiP Window Content - always render when pipWindow exists so mini PiP is never blank (e.g. when returning to home) */}
              {pipWindow && (
                <DocumentPiP pipWindow={pipWindow}>
                  <PiPContent
                    meetingTitle={meetingTitle}
                    recordingTime={recordingTime}
                          isRecording={isRecording}
                          paused={paused}
                          isMicActive={isMicActive}
                          isSystemActive={isSystemActive}
                          volume={volume}
                          activeMicrophone={activeMicrophone}
                          microphones={microphones}
                          onMicClick={handleMicClick}
                          onSystemClick={handleSystemClick}
                          onPauseClick={handlePauseClick}
                          onResumeClick={handleResume}
                          onStopClick={handleStopClickFromPiP}
                          onClose={handleClosePiP}
                          onExpand={handleExpandPiP}
                          selectMicrophone={selectMicrophone}
                          streamRef={streamRef}
                          transcriptContent={content || ''}
                        />
                      </DocumentPiP>
                    )}
                  </Box>
                </>
              )}

              {/* =========================================================
                MOBILE & TABLET VIEW (New Layout)
               ========================================================= */}
            {isMobileView && (
              <Box
                className="mobile-view-wrapper"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 'calc(100vh - 175px)',
                  overflow: 'hidden',
                  backgroundColor: 'white',
                }}
              >
                <Box
                  className="page-header"
                  sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    backgroundColor: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    borderBottom: '1px solid var(--grey-200)',
                    padding: 0,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      padding: '8px 16px',
                    }}
                  >
                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
                      <MeetingTitle
                        meetingTitle={meetingTitle}
                        isEditingTitle={isEditingTitle}
                        setIsEditingTitle={setIsEditingTitle}
                        setMenuSeleted={navigate}
                        details={details}
                        handleTitleSave={handleTitleSave}
                        meeting_id={meeting_id}
                        handleTitleEdit={handleTitleEdit}
                        handleTitleBlur={handleTitleBlur}
                        setShowSummary={setShowSummary}
                        isDetailsView={
                          Object.keys(meetingAPIDetails).length > 0 &&
                          details.isDetailsView
                        }
                        setMeetingAPIDetails={setMeetingAPIDetails}
                        meetingAPIDetails={meetingAPIDetails}
                      />
                      {isPhoneView ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 0.5,
                            minWidth: 0,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: 'text.secondary',
                              fontWeight: 500,
                              fontSize: '14px',
                              minWidth: 0,
                              flex: 1,
                              pr: 1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              marginLeft: '26px',

                            }}
                            noWrap
                          >
                            {new Date().toLocaleDateString('en-US')} •{' '}
                            <span
                              style={{
                                color:
                                  isRecording && !paused ? 'parimary.300' : 'inherit',
                              }}
                            >
                              {paused ? 'Paused' : isRecording ? 'Listening...' : 'Stopped'}
                            </span>
                          </Typography>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 2,
                              flexShrink: 0,
                              minWidth: 0,
                            }}
                          >
                            {showMobileStartTime && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <StartTime fontSize="small" sx={{ color: 'grey.400' }} />
                                <Typography variant="body2" fontWeight={500} color="text.primary">
                                  {details.meetingDetails.startTime}
                                </Typography>
                              </Box>
                            )}
                            {renderActionIcons()}
                          </Box>
                        </Box>
                      ) : (
                        <Typography
                          variant="caption"
                          sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            // mt: 0.5,
                            fontSize: '14px',
                            marginLeft: '26px'
                          }}
                        >
                          {new Date().toLocaleDateString('en-US')} •{' '}
                          <span
                            style={{
                              color: isRecording && !paused ? 'primary.300' : 'inherit',
                            }}
                          >
                            {paused ? 'Paused' : isRecording ? 'Listening...' : 'Stopped'}
                          </span>
                        </Typography>
                      )}
                    </Box>

                    {/* RIGHT SIDE: Action Icons */}
                    {!isPhoneView && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                        }}
                      >
                        {renderActionIcons()}
                      </Box>
                    )}
                  </Box>
                  {/* --- ROW 2: Tabs (Transcript / Summary) --- */}
                  <Box sx={{ width: '100%', bgcolor: 'white' }}>
                    <Tabs
                      value={showSummary ? 1 : 0}
                      onChange={(event, newValue) => {
                        if (newValue === 0) {
                          setShowSummary(false);
                        } else {
                          if (
                            (Object.keys(details).length > 0 &&
                              details.isDetailsView) ||
                            currentMeetingDetails.stopped
                          ) {
                            setShowSummary(true);
                          }
                        }
                      }}
                      variant="fullWidth"
                      textColor="primary"
                      indicatorColor="primary"
                      aria-label="meeting content tabs"
                      sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        minHeight: '40px',
                        '& .MuiTab-root': {
                          textTransform: 'none',
                          fontWeight: 500,
                          fontSize: '14px',
                          minHeight: '40px',
                          gap: 1,
                          transition: 'all 0.2s',
                        },
                        '& .MuiTabs-indicator': {
                          height: '2px',
                          borderRadius: '0',
                        },
                      }}
                    >
                      <Tab
                        icon={<Assignment fontSize="small" />}
                        iconPosition="start"
                        label="Transcript"
                        sx={{
                          ...getTabButtonSx(!showSummary, false),
                          ...(showSummary
                            ? {
                              bgcolor: 'transparent',
                              borderRadius: 0,
                              '&:hover': {
                                ...(getTabButtonSx(!showSummary, false)['&:hover'] || {}),
                                borderRadius: 0,
                              },
                            }
                            : {}),
                        }}
                      />
                      <Tab
                        disabled={summaryDisabled}
                        icon={<GenieIconNew style={{ fontSize: '18px' }} />}
                        iconPosition="start"
                        label="Summary"
                        sx={{
                          ...getTabButtonSx(showSummary, summaryDisabled),
                          ...(!showSummary
                            ? {
                              bgcolor: 'transparent',
                              borderRadius: 0,
                              '&:hover': {
                                ...(getTabButtonSx(showSummary, summaryDisabled)['&:hover'] || {}),
                                borderRadius: 0,
                              },
                            }
                            : {}),
                          '&.Mui-disabled': {
                            opacity: 0.5,
                            cursor: 'not-allowed !important',
                          },
                        }}
                      />
                    </Tabs>
                  </Box>
                </Box>

                {/* --- Main Content Area --- */}
                <Box
                  ref={transcriptContentRef}
                  className="main-content"
                  sx={{
                    padding: '0px 16px 16px 16px',
                    mt: '24px',
                    overflowY: 'auto',
                    flex: '1 1 0',
                    minHeight: 0,
                    '& .MuiTypography-root': {
                      color: 'text.primary',
                    },
                  }}
                  id="transcript-content"
                >
                  {currentPath === ROUTES.HOME && isPiPOpen ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: 'calc(100vh - 320px)',
                        width: '100%',
                      }}
                    >
                      <PiPEmptyStateSvg
                        width="100%"
                        height="auto"
                        style={{ maxWidth: 660, minHeight: 280 }}
                      />
                    </Box>
                  ) : showSummary ? (
                    <MeetingMinutesEditor
                      summaryContext={summaryContext}
                      setSummaryContext={setSummaryContext}
                      handleSumbit={handleSumbit}
                      markdownToQuill={markdownToQuill}
                    />
                  ) : (
                    <>
                      {!hasFirstChunk && isRecording ? (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: 'calc(100vh - 500px)',
                            flexDirection: 'column',
                            gap: 2,
                          }}
                        >
                          <LoadingCogSvg width={300} height={300} />
                        </Box>
                      ) : (
                        <Typography
                          variant="body2"
                          component="div"
                          sx={{ mb: '10px' }}
                          dangerouslySetInnerHTML={{ __html: content || '' }}
                        />
                      )}
                    </>
                  )}
                </Box>
                <Box
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    zIndex: 10,
                    marginBottom: '20px',
                    backgroundColor: 'white',
                    // padding: '16px',
                    padding: isBrowser ? '0px' : 0,
                    // Hide mini bar on home when PIP is open (user opened PIP via button)
                    ...(currentPath === ROUTES.HOME && isPiPOpen && { display: 'none' }),
                  }}
                >
                  <AudioControl
                    setDetails={setDetails}
                    startRecording={startRecording}
                    stopRecording={stopRecording}
                    isRecording={isRecording}
                    pauseRecording={pauseRecording}
                    setShowSummary={setShowSummary}
                    handleSumbit={handleSumbit}
                    showSummary={showSummary}
                    setLoading={setLoading}
                    loading={loading}
                    handleTitleUpdate={handleTitleUpdate}
                    setMeetingAPIDetails={setMeetingAPIDetails}
                    transScriptSession={transScriptSession}
                    meetingAPIDetails={meetingAPIDetails}
                    details={details}
                    isViewDetails={
                      !(
                        (Object.keys(details).length > 0 &&
                          details.isResume) ||
                        !(Object.keys(details).length > 0)
                      )
                    }
                    resumeRecording={resumeRecording}
                    streamRef={streamRef}
                    isHome={isHome}
                    resetTimer={resetTimer}
                    setMenuSeleted={navigate}
                    setSummaryContext={setSummaryContext}
                    summaryContext={summaryContext}
                    microphones={microphones}
                    activeMicrophone={activeMicrophone}
                    volume={volume}
                    microphoneError={microphoneError}
                    selectMicrophone={selectMicrophone}
                    isMicActive={isMicActive}
                    isSystemActive={isSystemActive}
                    clearMicSpeaker={clearMicSpeaker}
                    resetAll={resetAll}
                    currentPath={currentPath}
                    recordingTime={recordingTime}
                    formatTime={formatTime}
                  />
                  {/* PiP Window Content - always render when pipWindow exists so mini PiP is never blank */}
                  {pipWindow && (
                    <DocumentPiP pipWindow={pipWindow}>
                      <PiPContent
                        meetingTitle={meetingTitle}
                        recordingTime={recordingTime}
                        isRecording={isRecording}
                        paused={paused}
                        isMicActive={isMicActive}
                        isSystemActive={isSystemActive}
                        volume={volume}
                        activeMicrophone={activeMicrophone}
                        microphones={microphones}
                        onMicClick={handleMicClick}
                        onSystemClick={handleSystemClick}
                        onPauseClick={handlePauseClick}
                        onResumeClick={handleResume}
                        onStopClick={handleStopClickFromPiP}
                        onClose={handleClosePiP}
                        onExpand={handleExpandPiP}
                        selectMicrophone={selectMicrophone}
                        streamRef={streamRef}
                        transcriptContent={content || ''}
                      />
                    </DocumentPiP>
                  )}
                </Box>
              </Box>
            )}
          </>
        )}
      </Stack>

      {/* Share Dialog - Mobile View (only when coming from history, not from recycle bin) */}
      {isMobileView && isDetailsView && !currentPath.startsWith('/transcriber/bin/meeting/') && (
        <SwipeableDrawer
          anchor="bottom"
          open={openShareDialog}
          onClose={handleShareDialogClose}
          onOpen={() => {}}
          disableSwipeToOpen={true}
          PaperProps={{
            sx: {
              borderTopLeftRadius: '24px',
              borderTopRightRadius: '24px',
              paddingBottom: '24px',
              maxHeight: '90vh',
            },
          }}
        >
          {/* The "Puller" Bar - The grey line at the top */}
          <Box
            sx={{
              width: 40,
              height: 6,
              backgroundColor: 'grey.300',
              borderRadius: 3,
              position: 'absolute',
              top: 8,
              left: 'calc(50% - 20px)',
            }}
          />

          {/* Header Section */}
          <Box sx={{ padding: '24px 24px 16px 24px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                <LinkIcon sx={{ color: 'primary.main' }} />
                <Typography variant="h6" component="span" fontWeight={600}>
                  Share link
                </Typography>
              </Box>
              <IconButton
                aria-label="close"
                onClick={handleShareDialogClose}
                size="small"
                sx={{ color: 'text.secondary' }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Content Section */}
          <Box sx={{ padding: '0px 24px' }}>
            {isLoadingShare && !shareUrl ? (
              <Box display="flex" justifyContent="center" flexWrap={'wrap'} py={4}>
                <Typography variant="body2" color="text.secondary">
                  Loading share URL...
                </Typography>
              </Box>
            ) : shareUrl ? (
              <Stack spacing={3}>
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={500}
                    sx={{ mb: 1, display: 'block' }}
                  >
                    URL
                  </Typography>
                  <Box display="flex" gap={1} flexWrap={'nowrap'}>
                    <TextField
                      id="share-url"
                      name="shareUrl"
                      fullWidth
                      value={shareUrl}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'var(--grey-50)',
                          fontSize: '14px',
                        },
                      }}
                    />
                    <Tooltip title={shareCopied ? "Copied!" : "Copy link"}>
                      <IconButton
                        size="small"
                        onClick={handleCopyShareUrl}
                        color="primary"
                        sx={{
                          border: '1px solid',
                          borderColor: 'bluegrey.500',
                          borderRadius: 1,
                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={500}
                    sx={{ mb: 2, display: 'block' }}
                  >
                    Share using
                  </Typography>
                  <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
                    <Grid item xs={4} sm={3}>
                      <WhatsappShareButton
                        url={shareUrl}
                        style={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 8,
                          padding: '12px',
                          border: '1px solid var(--grey-100)',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          cursor: 'pointer',
                          textDecoration: 'none',
                          transition: 'all 0.2s',
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.backgroundColor = 'var(--grey-50)';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                      >
                        <WhatsAppIcon sx={{ fontSize: 28 }} />
                        <Typography variant="caption" color="text.primary">
                          WhatsApp
                        </Typography>
                      </WhatsappShareButton>
                    </Grid>
                    <Grid item xs={4} sm={3} sx={{ width: '90px' }}>
                      <Box
                        component="div"
                        onClick={() => {
                          window.location.href = gmailLink;
                        }}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 1,
                          padding: '12px',
                          border: '1px solid var(--grey-100)',
                          borderRadius: '8px',
                          backgroundColor: 'transparent',
                          cursor: 'pointer',
                          height: '86px',
                          transition: 'all 0.2s',
                          '&:hover': {
                            backgroundColor: 'var(--grey-50)',
                          },
                        }}
                      >
                        <GMailIcon sx={{ fontSize: 28, color: '#EA4335' }} />
                        <Typography variant="caption" color="text.primary">
                          Email
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            ) : null}
          </Box>
        </SwipeableDrawer>
      )}

      {/* Inactivity Dialog - hidden when Silero VAD is disabled */}
      {/* <InactivityDialog
        open={inactivityDialogOpen}
        silenceDuration={vadSilenceDuration}
        recordingTime={recordingTime}
        onResume={handleInactivityResume}
        onStop={handleInactivityStop}
      /> */}

      <Dialog
        open={pipLastSourceDialogOpen}
        onClose={handlePipLastSourceCancel}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography variant="subtitle1" fontWeight={600}>
            Pause Meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            Disabling the last audio source will pause the meeting. Do you want
            to continue?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePipLastSourceCancel}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handlePipLastSourceProceed}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default TranscriberDetail;
